(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sb-contact-form').forEach((section) => {
    const form = section.querySelector('.sb-contact-form__form');
    if (!form) return;

    const errorNode = section.querySelector('[data-sb-contact-error]');
    const errorTextNode = section.querySelector('[data-sb-contact-error-text]');
    const successNode = section.querySelector('[data-sb-contact-success]');
    const submitButton = form.querySelector('.sb-contact-form__submit');
    const copy = {
      required: section?.dataset.errorRequired || 'Please fill in all required fields',
      invalidEmail: section?.dataset.errorInvalidEmail || 'Please enter a valid email address',
      generic: section?.dataset.errorGeneric || 'Something went wrong, please try again',
      sending: section?.dataset.sendingLabel || '',
    };

    if (submitButton && !submitButton.querySelector('.sb-button-spinner')) {
      const spinner = document.createElement('span');
      spinner.className = 'sb-button-spinner sb-button-spinner--inline';
      spinner.setAttribute('aria-hidden', 'true');
      submitButton.prepend(spinner);
    }

    const fields = () => Array.from(form.querySelectorAll('.sb-field input, .sb-field textarea'));

    const setError = (message) => {
      if (errorTextNode) errorTextNode.textContent = message || '';
      if (errorNode) errorNode.hidden = !message;
      if (message && successNode) successNode.hidden = true;
    };

    const showValidationErrors = () => {
      let missing = false;
      let badEmail = false;
      let invalid = false;
      let firstInvalid = null;

      fields().forEach((input) => {
        input.closest('.sb-field')?.classList.remove('is-error');
        const value = `${input.value || ''}`.trim();
        const failsEmailGate = input.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
        const failsNativeGate = !input.validity.valid;

        if (!failsEmailGate && !failsNativeGate) return;

        firstInvalid ||= input;
        input.closest('.sb-field')?.classList.add('is-error');
        if (input.validity.valueMissing) missing = true;
        else if (failsEmailGate || input.validity.typeMismatch) badEmail = true;
        else invalid = true;
      });

      const message = missing ? copy.required : badEmail ? copy.invalidEmail : invalid ? copy.generic : '';
      setError(message);
      firstInvalid?.focus();
      return Boolean(message);
    };

    fields().forEach((input) => {
      input.addEventListener('input', () => {
        input.closest('.sb-field')?.classList.remove('is-error');
        setError('');
      });
    });

    // Keep native constraint validation as the first safety net, but replace
    // its browser-specific bubble with the shared translated form message.
    // This also prevents malformed fields from ever reaching Shopify.
    let validationQueued = false;
    form.addEventListener('invalid', (event) => {
      event.preventDefault();
      if (validationQueued) return;
      validationQueued = true;
      queueMicrotask(() => {
        validationQueued = false;
        showValidationErrors();
      });
    }, true);

    // Valid submissions remain native so Shopify owns delivery, captcha, and
    // the one-time success flag on the redirect back.
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted || !submitButton) return;
      submitButton.disabled = false;
      submitButton.classList.remove('is-loading');
      const labelNode = submitButton.querySelector('.sb-button-radiant__label');
      const sendLabel = `${submitButton.dataset.sendLabel || ''}`.trim();
      if (labelNode && sendLabel) labelNode.textContent = sendLabel;
    });

    form.addEventListener('submit', (event) => {
      if (showValidationErrors()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (submitButton) {
        const labelNode = submitButton.querySelector('.sb-button-radiant__label');
        if (labelNode && !submitButton.dataset.sendLabel) {
          submitButton.dataset.sendLabel = labelNode.textContent.trim();
        }
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        if (labelNode && copy.sending) labelNode.textContent = copy.sending;
      }
    }, true);
  });

  // Hovering the resize grip should not light up the whole field: stamp
  // is-grip-hover while the pointer sits in the wrapper's bottom-right corner
  // zone (the grip area), which the shared CSS uses to mute the hover glow.
  document.querySelectorAll('.sb-field--multiline').forEach((field) => {
    const GRIP_ZONE = 24;
    field.addEventListener('pointermove', (event) => {
      const rect = field.getBoundingClientRect();
      const inCorner = rect.right - event.clientX <= GRIP_ZONE && rect.bottom - event.clientY <= GRIP_ZONE;
      field.classList.toggle('is-grip-hover', inCorner);
    });
    field.addEventListener('pointerleave', () => {
      field.classList.remove('is-grip-hover');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroes = new Map();

    const initializeHero = (heroRoot) => {
      if (heroes.has(heroRoot)) return;
      const controller = new AbortController();
      const { signal } = controller;

      const priceRoot = heroRoot.querySelector('[data-product-hero-price-root]');
      const currencyCode = `${priceRoot?.dataset.currency || ''}`.trim().toUpperCase();
      const productId = priceRoot?.dataset.productId || '';
      const hideDiscounts = priceRoot?.dataset.hideDiscounts === 'true';
      const variantIds = String(priceRoot?.dataset.productVariantIds || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
      const variantIdSet = new Set(variantIds);

      const storefrontPricing = window.SBStorefrontPricing || null;

      const formatMoney = (amountInCents) => {
        const normalizedCents = Number(amountInCents || 0);
        if (storefrontPricing && typeof storefrontPricing.formatMoney === 'function') {
          return storefrontPricing.formatMoney(normalizedCents, currencyCode, { context: 'storefront' });
        }
        return `${Math.round(normalizedCents / 100)}`;
      };

      const parseMoneyCents = (value) => {
        if (value === null || value === undefined || value === '') return null;
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
      };

      const resolveDisplayPrice = (priceCents, comparePriceCents) => {
        if (hideDiscounts) {
          return { currentPriceCents: Number(priceCents) || 0, comparePriceCents: null };
        }
        if (storefrontPricing && typeof storefrontPricing.resolvePrice === 'function') {
          const resolved = storefrontPricing.resolvePrice({
            productId,
            priceCents,
            comparePriceCents,
          }) || {};
          const currentPriceCents = Number(resolved.currentPriceCents);
          const resolvedComparePriceCents = Number(resolved.comparePriceCents);
          return {
            currentPriceCents: Number.isFinite(currentPriceCents) ? currentPriceCents : Number(priceCents || 0),
            comparePriceCents:
              Number.isFinite(resolvedComparePriceCents) && resolvedComparePriceCents > currentPriceCents
                ? resolvedComparePriceCents
                : null,
          };
        }

        const normalizedPrice = Number(priceCents || 0);
        const normalizedCompare = Number(comparePriceCents || 0);
        return {
          currentPriceCents: normalizedPrice,
          comparePriceCents: normalizedCompare > normalizedPrice ? normalizedCompare : null,
        };
      };

      let activePriceVariant = null;
      const applyVariantPrice = (variant) => {
        const currentPriceElement = heroRoot.querySelector('[data-product-hero-current-price]');
        const comparePriceElement = heroRoot.querySelector('[data-product-hero-compare-price]');
        if (!variant || !currentPriceElement) return;
        activePriceVariant = variant;
        const nextPrice = parseMoneyCents(variant.price);
        if (nextPrice === null) return;
        const nextComparePrice = parseMoneyCents(variant.compare_at_price);
        const resolvedPricing = resolveDisplayPrice(nextPrice, nextComparePrice);

        currentPriceElement.textContent = formatMoney(resolvedPricing.currentPriceCents);

        if (!comparePriceElement) return;
        if (resolvedPricing.comparePriceCents !== null && resolvedPricing.comparePriceCents > resolvedPricing.currentPriceCents) {
          comparePriceElement.textContent = formatMoney(resolvedPricing.comparePriceCents);
          comparePriceElement.hidden = false;
        } else {
          comparePriceElement.textContent = '';
          comparePriceElement.hidden = true;
        }
      };

      applyVariantPrice({
        id: priceRoot?.dataset.initialVariantId || '',
        price: parseMoneyCents(priceRoot?.dataset.initialPrice),
        compare_at_price: parseMoneyCents(priceRoot?.dataset.initialComparePrice),
      });

      document.addEventListener('variant:update', (event) => {
        const variant = event?.detail?.resource;
        if (!variant) return;
        const variantId = String(variant.id || '').trim();
        if (!variantId) return;

        const sourceRoot = event.target && event.target.closest ? event.target.closest('.sb-product-main') : null;
        const sourceProductId = sourceRoot?.dataset?.productId || '';
        if (productId && sourceProductId && sourceProductId !== productId) return;
        if (!sourceProductId && variantIdSet.size && !variantIdSet.has(variantId)) return;
        if (parseMoneyCents(variant.price) === null) return;

        applyVariantPrice(variant);
      }, { signal });

      document.addEventListener('sb:storefront-pricing:changed', () => {
        if (activePriceVariant) applyVariantPrice(activePriceVariant);
      }, { signal });

      // Shared decoder recovery can replace the video element.
      const responsiveMediaVideos = () => Array.from(heroRoot.querySelectorAll('video[data-responsive-video]'));
      const mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      const responsiveVideoCleanups = new WeakMap();

      const responsiveVideoSource = (video) => {
        const source = mobileMediaQuery.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        return (source || '').trim();
      };

      const initializeResponsiveHeroVideos = () => {
        responsiveMediaVideos().forEach((video) => {
          if (!(video instanceof HTMLVideoElement)) return;
          video.dataset.activeSrc = responsiveVideoSource(video);
        });
      };

      const syncResponsiveHeroVideos = () => {
        responsiveMediaVideos().forEach((video) => {
          if (!(video instanceof HTMLVideoElement)) return;
          const nextSource = responsiveVideoSource(video);
          if (!nextSource || video.dataset.activeSrc === nextSource) return;

          video.dataset.activeSrc = nextSource;
          window.SBMediaLoader?.video.conceal(video);

          // Poster videos already reveal through the shared presented-frame lifecycle.
          // Only native videos without that lifecycle need a temporary visibility guard.
          if (!video.hasAttribute('data-sb-media-poster-video')) {
            responsiveVideoCleanups.get(video)?.();
            video.classList.add('is-switching-source');

            const cleanup = () => {
              video.removeEventListener('loadeddata', reveal);
              video.removeEventListener('error', reveal);
              responsiveVideoCleanups.delete(video);
            };
            const reveal = () => {
              video.classList.remove('is-switching-source');
              cleanup();
            };

            responsiveVideoCleanups.set(video, cleanup);
            video.addEventListener('loadeddata', reveal);
            video.addEventListener('error', reveal);
          }
          video.setAttribute('src', nextSource);
          video.load();
        });
      };

      if (responsiveMediaVideos().length > 0) {
        initializeResponsiveHeroVideos();
        if (typeof mobileMediaQuery.addEventListener === 'function') {
          mobileMediaQuery.addEventListener('change', syncResponsiveHeroVideos, { signal });
        } else if (typeof mobileMediaQuery.addListener === 'function') {
          mobileMediaQuery.addListener(syncResponsiveHeroVideos);
          signal.addEventListener('abort', () => mobileMediaQuery.removeListener(syncResponsiveHeroVideos), { once: true });
        }
      }

      const syncWatchVideoVisibility = (event) => {
        const watchVideoButton = heroRoot.querySelector('.sb-hero-section__watch-video-button');
        const watchVideoActions = watchVideoButton?.closest('.sb-hero-section__actions');
        const href = watchVideoButton?.getAttribute('href') || '';
        const target = href.startsWith('#') ? document.getElementById(href.slice(1)) : null;
        const unloadingTarget = event?.type === 'shopify:section:unload' && event.target.contains(target);
        if (watchVideoActions) watchVideoActions.hidden = !target || unloadingTarget;
      };

      syncWatchVideoVisibility();
      document.addEventListener('shopify:section:load', syncWatchVideoVisibility, { signal });
      document.addEventListener('shopify:section:unload', syncWatchVideoVisibility, { signal });

      heroes.set(heroRoot, () => {
        controller.abort();
        responsiveMediaVideos().forEach((video) => responsiveVideoCleanups.get(video)?.());
      });
    };

    const initialize = (scope = document) => {
      if (scope.matches?.('[data-product-hero]')) initializeHero(scope);
      scope.querySelectorAll('[data-product-hero]').forEach(initializeHero);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      heroes.forEach((cleanup, heroRoot) => {
        if (!event.target.contains(heroRoot)) return;
        cleanup();
        heroes.delete(heroRoot);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadLinkedFrames = (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
      if (!trigger || (event.type === 'pointerover' && trigger.contains(event.relatedTarget))) return;

      const sectionRoot = document.getElementById(trigger.getAttribute('href').slice(1));
      if (sectionRoot?.matches('[data-hero-video-anchor]')) {
        window.SBMediaLoader?.activate(sectionRoot);
      }
    };

    document.addEventListener('click', loadLinkedFrames);
    document.addEventListener('focusin', loadLinkedFrames);
    document.addEventListener('pointerover', loadLinkedFrames);

    const initializeHeroVideoImages = (root = document) => {
      const images = Array.from(root.querySelectorAll('img[data-hero-video-thumb-image]'));
      if (!images.length) return;

      images.forEach((image) => {
        if (!(image instanceof HTMLImageElement) || image.dataset.heroVideoImageInit === 'true') return;
        image.dataset.heroVideoImageInit = 'true';

        const fallbackQueue = [image.dataset.fallbackPrimary, image.dataset.fallbackSecondary].filter(Boolean);
        let fallbackIndex = 0;

        const applyFallback = () => {
          if (fallbackIndex >= fallbackQueue.length) return;
          const nextSource = fallbackQueue[fallbackIndex];
          fallbackIndex += 1;
          if (!nextSource) return;

          image.setAttribute('srcset', '');
          image.src = nextSource;
        };

        image.addEventListener('error', applyFallback);
        if (image.complete && image.currentSrc && image.naturalWidth === 0) applyFallback();
      });
    };

    const initializeHeroVideoGalleries = (root = document) => {
      const galleries = Array.from(root.querySelectorAll('[data-hero-video-gallery]'));
      if (!galleries.length) return;

      galleries.forEach((galleryRoot) => {
        if (galleryRoot.dataset.heroVideoInit === 'true') return;
        galleryRoot.dataset.heroVideoInit = 'true';

        const featuredFrame = galleryRoot.querySelector('[data-hero-video-featured-frame]');
        const thumbnails = Array.from(galleryRoot.querySelectorAll('[data-hero-video-thumb]'));
        if (!featuredFrame || !thumbnails.length) return;

        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            const youtubeId = (thumbnail.dataset.heroVideoId || '').trim();
            if (!youtubeId) return;

            const nextSource = `https://www.youtube.com/embed/${youtubeId}?rel=0&autoplay=1`;
            featuredFrame.dataset.sbMediaSrc = nextSource;
            window.SBMediaLoader?.activate(featuredFrame.closest('[data-sb-media-load]') || featuredFrame);

            const nextTitle = (thumbnail.dataset.heroVideoTitle || '').trim();
            if (nextTitle) {
              featuredFrame.setAttribute('title', nextTitle);
            }

            thumbnails.forEach((item) => {
              item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false');
            });
          });
        });
      });
    };

    const initializeAll = (scope = document) => {
      initializeHeroVideoImages(scope);
      initializeHeroVideoGalleries(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["large-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedVariantMedia = new Map();

    const initLargeFeatureVariantMedia = (root) => {
      if (!root || initializedVariantMedia.has(root)) return;
      const controller = new AbortController();
      const { signal } = controller;

      const colorChips = Array.from(root.querySelectorAll('[data-large-feature-color-chip]'));
      const frameCache = new Map();
      let mediaSwitchRequestId = 0;

      const getFrameKey = (frame) => `${frame?.dataset.largeFeatureMediaKey || 'fallback'}`;
      const getActiveFrame = () => root.querySelector('[data-large-feature-media-active]')
        || root.querySelector('[data-large-feature-media-frame]:not([hidden])');
      const cacheFrame = (frame) => {
        if (!(frame instanceof HTMLElement)) return;
        frameCache.set(getFrameKey(frame), frame);
      };
      const pauseFrame = (frame) => {
        frame?.querySelector('video')?.pause();
      };
      const playFrame = (frame) => {
        const video = frame?.querySelector('video');
        if (!(video instanceof HTMLVideoElement)) return;
        if (window.SBMediaLoader?.video?.play) {
          window.SBMediaLoader.video.play(video);
        } else {
          video.play().catch(() => {});
        }
      };
      const getPlaybackPosition = (frame) => {
        const video = frame?.querySelector('video');
        if (!(video instanceof HTMLVideoElement)) return null;

        const currentTime = Number.isFinite(video.currentTime) ? Math.max(video.currentTime, 0) : 0;
        const duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : 0;
        const loopTime = duration > 0 ? currentTime % duration : currentTime;
        return {
          progress: duration > 0 ? loopTime / duration : null,
          time: loopTime,
        };
      };
      const waitForMediaEvent = (video, eventNames, timeout = 1200) => new Promise((resolve) => {
        if (signal.aborted) return resolve();
        let settled = false;
        const cleanup = () => {
          eventNames.forEach((eventName) => video.removeEventListener(eventName, finish));
          signal.removeEventListener('abort', finish);
          window.clearTimeout(timeoutId);
        };
        const finish = () => {
          if (settled) return;
          settled = true;
          cleanup();
          resolve();
        };
        const timeoutId = window.setTimeout(finish, timeout);
        signal.addEventListener('abort', finish, { once: true });
        eventNames.forEach((eventName) => video.addEventListener(eventName, finish, { once: true }));
      });
      const waitForPresentedFrame = (video, timeout = 1200) => new Promise((resolve) => {
        if (signal.aborted) return resolve(false);
        let settled = false;
        let callbackId = null;
        const finish = (presented) => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          signal.removeEventListener('abort', abort);
          video.removeEventListener('playing', handlePlayback);
          video.removeEventListener('timeupdate', handlePlayback);
          if (
            callbackId !== null
            && typeof video.cancelVideoFrameCallback === 'function'
          ) {
            video.cancelVideoFrameCallback(callbackId);
          }
          resolve(presented);
        };
        const handlePlayback = () => {
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => finish(true));
          });
        };
        const abort = () => finish(false);
        const timeoutId = window.setTimeout(abort, timeout);
        signal.addEventListener('abort', abort, { once: true });

        if (typeof video.requestVideoFrameCallback === 'function') {
          callbackId = video.requestVideoFrameCallback(() => finish(true));
          return;
        }
        video.addEventListener('playing', handlePlayback, { once: true });
        video.addEventListener('timeupdate', handlePlayback, { once: true });
      });
      const waitForImage = (image) => new Promise((resolve) => {
        if (signal.aborted) return resolve(false);
        const finish = (ready) => {
          signal.removeEventListener('abort', cancel);
          resolve(ready);
        };
        const cancel = () => finish(false);
        signal.addEventListener('abort', cancel, { once: true });
        image.loading = 'eager';
        image.decode().then(() => finish(true), cancel);
      });
      const prepareFrameAtPosition = async (frame, playbackPosition, requestId) => {
        const video = frame?.querySelector('video');
        if (signal.aborted || requestId !== mediaSwitchRequestId || !(video instanceof HTMLVideoElement) || !playbackPosition) return;

        video.pause();
        if (video.readyState === HTMLMediaElement.HAVE_NOTHING) video.load();
        if (
          video.readyState < HTMLMediaElement.HAVE_METADATA
          || !Number.isFinite(video.duration)
          || video.duration <= 0
        ) {
          await waitForMediaEvent(video, ['loadedmetadata', 'durationchange']);
        }

        if (signal.aborted || requestId !== mediaSwitchRequestId) return;
        const duration = Number.isFinite(video.duration) && video.duration > 0 ? video.duration : 0;
        const targetTime = duration > 0 && Number.isFinite(playbackPosition.progress)
          ? Math.min(playbackPosition.progress * duration, Math.max(duration - 0.001, 0))
          : Math.min(playbackPosition.time, duration > 0 ? Math.max(duration - 0.001, 0) : playbackPosition.time);

        if (Math.abs(video.currentTime - targetTime) > 0.02) {
          const seeked = waitForMediaEvent(video, ['seeked'], 1200);
          try {
            video.currentTime = targetTime;
            await seeked;
          } catch {
            // If a browser rejects an early seek, keep the prepared first frame.
          }
        }
        if (signal.aborted || requestId !== mediaSwitchRequestId) return;
        if (video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
          await waitForMediaEvent(video, ['loadeddata', 'canplay']);
        }
      };
      const hideInactiveFrames = (activeFrame) => {
        root.querySelectorAll('[data-large-feature-media-frame]').forEach((frame) => {
          if (frame === activeFrame) return;
          if (!frame.hidden) pauseFrame(frame);
          frame.hidden = true;
          frame.removeAttribute('data-large-feature-media-active');
          frame.removeAttribute('data-large-feature-media-preparing');
        });
      };

      const initialFrame = getActiveFrame();
      if (initialFrame instanceof HTMLElement) initialFrame.dataset.largeFeatureMediaActive = 'true';
      root.querySelectorAll('[data-large-feature-media-frame]').forEach(cacheFrame);

      const getCurrentVariantId = () => `${
        root.dataset.currentVariantId
        || ''
      }`;

      const getTemplate = (variantId) => {
        const normalizedVariantId = `${variantId || ''}`;
        return root.querySelector(`[data-large-feature-media-template="${CSS.escape(normalizedVariantId)}"]`)
          || root.querySelector('[data-large-feature-media-template="fallback"]');
      };
      const setSelectedVariant = (variantId) => {
        const normalizedVariantId = `${variantId || ''}`;
        colorChips.forEach((chip) => {
          const isSelected = chip.dataset.variantId === normalizedVariantId;
          chip.classList.toggle('is-selected', isSelected);
          chip.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        root.dataset.currentVariantId = normalizedVariantId;
      };

      const syncVariantMedia = async (variantId) => {
        if (signal.aborted) return;
        const normalizedVariantId = `${variantId || ''}`;
        if (!normalizedVariantId) return;

        const requestId = ++mediaSwitchRequestId;
        setSelectedVariant(normalizedVariantId);

        const template = getTemplate(normalizedVariantId);
        const currentFrame = getActiveFrame();
        const nextKey = template?.dataset.largeFeatureMediaTemplate || 'fallback';

        if (!template || getFrameKey(currentFrame) === nextKey) {
          hideInactiveFrames(currentFrame);
          playFrame(currentFrame);
          return;
        }

        const playbackPosition = getPlaybackPosition(currentFrame) || { progress: null, time: 0 };
        pauseFrame(currentFrame);
        hideInactiveFrames(currentFrame);

        let nextFrame = frameCache.get(nextKey);
        if (!(nextFrame instanceof HTMLElement)) {
          nextFrame = template.content.firstElementChild?.cloneNode(true);
        }
        if (!(nextFrame instanceof HTMLElement)) {
          playFrame(currentFrame);
          return;
        }

        const isNewFrame = !nextFrame.isConnected;
        if (isNewFrame) {
          nextFrame.hidden = true;
          if (currentFrame instanceof HTMLElement) currentFrame.insertAdjacentElement('afterend', nextFrame);
          else root.prepend(nextFrame);
          const nextVideo = nextFrame.querySelector('video[data-sb-media-autoplay]');
          if (nextVideo && window.SBMediaLoader?.video?.register) {
            window.SBMediaLoader.video.register(nextVideo, { adopt: true });
          }
          cacheFrame(nextFrame);
        }

        await prepareFrameAtPosition(nextFrame, playbackPosition, requestId);
        if (signal.aborted || requestId !== mediaSwitchRequestId) return;

        const nextVideo = nextFrame.querySelector('video');
        const nextImage = nextFrame.querySelector('img');
        let presented = true;
        if (nextVideo instanceof HTMLVideoElement) {
          if (window.SBMediaLoader?.video.shouldAutoplay?.() !== false) {
            nextFrame.dataset.largeFeatureMediaPreparing = 'true';
            nextFrame.hidden = false;
            const presentedFrame = waitForPresentedFrame(nextVideo);
            playFrame(nextFrame);
            presented = await presentedFrame;
          }
          // A paused video can reuse its decoded still frame without presenting a new playback frame.
          if (window.SBMediaLoader?.video.shouldAutoplay?.() === false) {
            presented = nextVideo.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA && !nextVideo.error;
          }
        } else if (nextImage instanceof HTMLImageElement) {
          presented = await waitForImage(nextImage);
        }
        if (signal.aborted || requestId !== mediaSwitchRequestId) return;
        if (!presented) {
          pauseFrame(nextFrame);
          nextFrame.hidden = true;
          nextFrame.removeAttribute('data-large-feature-media-preparing');
          setSelectedVariant(getFrameKey(currentFrame));
          playFrame(currentFrame);
          return;
        }

        currentFrame?.removeAttribute('data-large-feature-media-active');
        if (currentFrame instanceof HTMLElement) currentFrame.hidden = true;
        nextFrame.removeAttribute('data-large-feature-media-preparing');
        nextFrame.hidden = false;
        nextFrame.dataset.largeFeatureMediaActive = 'true';
        hideInactiveFrames(nextFrame);
      };

      initializedVariantMedia.set(root, () => {
        controller.abort();
        root.querySelectorAll('video').forEach((video) => video.pause());
        frameCache.clear();
      });

      colorChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const variantId = `${chip.dataset.variantId || ''}`;
          if (!variantId || variantId === getCurrentVariantId()) return;
          syncVariantMedia(variantId);
        }, { signal });
      });

      if (root.hasAttribute('data-sync-product-variant')) {
        document.addEventListener('variant:update', (event) => {
          if (`${event.detail?.data?.productId || ''}` !== root.dataset.productId) return;
          syncVariantMedia(event.detail?.resource?.id);
        }, { signal });
      }

      syncVariantMedia(getCurrentVariantId());
    };

    const initLargeFeatureSection = (scope) => {
      if (!scope) return;
      if (scope.matches?.('[data-large-feature-variant-media]')) initLargeFeatureVariantMedia(scope);
      scope.querySelectorAll('[data-large-feature-variant-media]').forEach((root) => {
        initLargeFeatureVariantMedia(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initLargeFeatureSection(document), { once: true });
    } else {
      initLargeFeatureSection(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initLargeFeatureSection(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      initializedVariantMedia.forEach((cleanup, root) => {
        if (!event.target.contains(root)) return;
        cleanup();
        initializedVariantMedia.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Cookie parsing lives in window.SBAffiliateState (defined by the inline
    // head script in theme.liquid); prefer the prefetched mirror, re-checking
    // its expiry, before falling back to a fresh cookie read.
    const getAffiliateState = () => {
      const affiliateStateStore = window.SBAffiliateState;
      if (!affiliateStateStore) return null;
      return affiliateStateStore.normalize(window.SBAffiliateAnnouncementState) || affiliateStateStore.read();
    };

    const replaceToken = (input, token, replacement) => {
      const source = `${input || ''}`;
      const target = `${token || ''}`;
      if (!target) return source;
      return source.split(target).join(`${replacement || ''}`);
    };

    const resolvePromoFreeShippingThresholdDisplay = (promoBox) => {
      if (!(promoBox instanceof HTMLElement)) return '';
      const fallbackDisplay = `${promoBox.dataset.freeShippingThresholdDisplay || ''}`;
      const thresholdCents = Number.parseInt(`${promoBox.dataset.freeShippingThresholdCents || ''}`, 10);
      const currencyCode = `${promoBox.dataset.currency || ''}`.trim().toUpperCase();
      if (!Number.isFinite(thresholdCents) || thresholdCents <= 0) return fallbackDisplay;

      const storefrontPricing = window.SBStorefrontPricing || null;
      if (storefrontPricing && typeof storefrontPricing.formatMoney === 'function') {
        const formatted = storefrontPricing.formatMoney(thresholdCents, currencyCode, { context: 'storefront' });
        if (`${formatted || ''}`.trim() !== '') {
          promoBox.dataset.freeShippingThresholdDisplay = formatted;
          return formatted;
        }
      }

      return fallbackDisplay;
    };

    const resolvePromoTemplate = (promoBox, templateValue, state, thresholdDisplay) => {
      let resolved = `${templateValue || ''}`;
      resolved = replaceToken(resolved, promoBox.dataset.affiliateNameToken || '', state.affiliateName);
      resolved = replaceToken(resolved, promoBox.dataset.saleNameToken || '', state.affiliateName);
      resolved = replaceToken(resolved, promoBox.dataset.sitewideDiscountToken || '', promoBox.dataset.affiliateDiscountDepth || '');
      resolved = replaceToken(resolved, promoBox.dataset.shippingCountryToken || '', promoBox.dataset.shippingCountryName || '');
      resolved = replaceToken(
        resolved,
        promoBox.dataset.freeShippingThresholdToken || '',
        thresholdDisplay
      );
      return resolved.trim();
    };

    const applyAffiliatePromoState = (state, scope) => {
      if (!state) return;

      scope.querySelectorAll('.sb-blog-post [data-sidebar-promo-affiliate="true"]').forEach((promoBox) => {
        if (!(promoBox instanceof HTMLElement)) return;
        const titleElement = promoBox.querySelector('[data-sidebar-promo-title]');
        const textElement = promoBox.querySelector('[data-sidebar-promo-text]');
        const buttonLabelElement = promoBox.querySelector('[data-sidebar-promo-button-label]');
        const thresholdDisplay = resolvePromoFreeShippingThresholdDisplay(promoBox);

        const resolvedTitle = resolvePromoTemplate(promoBox, promoBox.dataset.sidebarPromoAffiliateTitleTemplate || '', state, thresholdDisplay);
        if (resolvedTitle && titleElement) {
          titleElement.textContent = resolvedTitle;
          promoBox.setAttribute('aria-label', resolvedTitle);
        }

        const resolvedText = resolvePromoTemplate(promoBox, promoBox.dataset.sidebarPromoTextTemplate || '', state, thresholdDisplay);
        if (resolvedText && textElement) {
          textElement.textContent = resolvedText;
        }

        const resolvedButtonLabel = resolvePromoTemplate(promoBox, promoBox.dataset.sidebarPromoButtonLabelTemplate || '', state, thresholdDisplay);
        if (resolvedButtonLabel && buttonLabelElement) {
          buttonLabelElement.textContent = resolvedButtonLabel;
        }

        const contextualButton = promoBox.querySelector('a[aria-label]');
        if (contextualButton && titleElement && buttonLabelElement) {
          contextualButton.setAttribute('aria-label', `${buttonLabelElement.textContent} ${titleElement.textContent}`);
        }
      });
    };

    applyAffiliatePromoState(getAffiliateState(), document);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) {
        applyAffiliatePromoState(getAffiliateState(), event.target);
      }
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stacks = new Map();

    const queueInlineStyle = (updates, element, property, value) => {
      if (element.style[property] !== value) updates.push({ element, property, value });
    };

    // Native sticky positioning handles scrolling. Only the boundary between
    // the two cards depends on the rendered article rows and card heights.
    const updateHandoff = () => {
      const gap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sb-space-36')) || 36;
      const styleUpdates = [];
      stacks.forEach((dependencies, stack) => {
        const first = stack.querySelector('[data-sb-sidebar-phase-1]');
        const second = stack.querySelector('[data-sb-sidebar-phase-2]');
        if (!first || !second) return;
        if (window.matchMedia('(max-width: 989px)').matches) {
          queueInlineStyle(styleUpdates, first, 'height', '');
          queueInlineStyle(styleUpdates, second, 'top', '');
          return;
        }
        const card = first.querySelector('[data-sb-sidebar-sticky-card]');
        const anchor = stack.closest('.sb-blog-overview__layout')?.querySelector('[data-sb-secondary-row-anchor]');
        const cardHeight = card.offsetHeight;
        const boundary = Math.max(cardHeight + gap, anchor
          ? anchor.getBoundingClientRect().top - stack.getBoundingClientRect().top
          : 0);
        queueInlineStyle(styleUpdates, first, 'height', `${boundary - gap}px`);
        queueInlineStyle(styleUpdates, second, 'top', `${boundary}px`);
      });
      styleUpdates.forEach(({ element, property, value }) => { element.style[property] = value; });
    };

    const observer = 'ResizeObserver' in window ? new ResizeObserver(updateHandoff) : null;
    const init = (scope) => {
      scope.querySelectorAll('[data-sb-blog-sidebar-stack]').forEach((stack) => {
        if (stacks.has(stack) || !stack.querySelector('[data-sb-sidebar-phase-2]')) return;
        const cards = Array.from(stack.querySelectorAll('[data-sb-sidebar-sticky-card]'));
        const featured = stack.closest('.sb-blog-overview__layout')?.querySelector('.sb-blog-overview__featured');
        const dependencies = featured ? [...cards, featured] : cards;
        stacks.set(stack, dependencies);
        if (observer) {
          cards.forEach(card => observer.observe(card));
          if (featured) observer.observe(featured);
        }
      });
      updateHandoff();
    };
    document.addEventListener('shopify:section:unload', (event) => {
      stacks.forEach((dependencies, stack) => {
        if (!event.target.contains(stack)) return;
        dependencies.forEach(element => observer?.unobserve(element));
        stacks.delete(stack);
      });
    });
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    if (!observer) {
      window.addEventListener('resize', updateHandoff);
      window.addEventListener('load', updateHandoff, { once: true });
    }
    init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partnership-password-gate"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'sb-partnership-password-unlocked-v2';
    const encoder = new TextEncoder();

    const hashValue = async (value) => {
      const digest = await crypto.subtle.digest('SHA-256', encoder.encode(value));
      return Array.from(new Uint8Array(digest))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');
    };

    const initializeGate = (gate) => {
      const form = gate.querySelector('[data-password-form]');
      const field = gate.querySelector('[data-password-field]');
      const input = gate.querySelector('[data-password-input]');
      const error = gate.querySelector('[data-password-error]');
      const expectedHash = gate.getAttribute('data-password-hash') || '';
      if (!form || !field || !input || !expectedHash) return;

      const resetPageScroll = () => {
        const scrollingElement = document.scrollingElement || document.documentElement;
        scrollingElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);
      };

      const resetPageMotion = () => {
        // The content sections are display:none while the gate shows, so the
        // deferred section-motion.js skipped their reveal roots at its own
        // initialize. Re-init them now that they are visible - synchronously
        // when the motion API is present, else once at DOMContentLoaded
        // (which fires after deferred scripts, so the API exists by then;
        // the old rAF + event fallback could fire before the listener was
        // registered and the reset was silently lost).
        const applyReset = () => {
          if (window.SBSectionMotion && typeof window.SBSectionMotion.resetScope === 'function') {
            window.SBSectionMotion.resetScope(document);
            return true;
          }
          return false;
        };
        if (applyReset()) return;
        document.addEventListener('DOMContentLoaded', () => {
          applyReset();
        }, { once: true });
      };

      const setUnlocked = ({ resetScroll = false } = {}) => {
        try {
          sessionStorage.setItem(storageKey, 'true');
        } catch (_) {}
        if (resetScroll) input.blur();
        gate.hidden = true;
        resetPageMotion();
        if (!resetScroll) return;

        resetPageScroll();
        requestAnimationFrame(() => {
          resetPageScroll();
          requestAnimationFrame(resetPageScroll);
        });
      };

      let previouslyUnlocked = false;
      try {
        previouslyUnlocked = sessionStorage.getItem(storageKey) === 'true';
      } catch (_) {}
      if (previouslyUnlocked) {
        setUnlocked();
        return;
      }

      input.addEventListener('input', () => {
        field.classList.remove('is-error');
        if (error) error.hidden = true;
      });

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        requestAnimationFrame(() => {
          input.focus({ preventScroll: true });
        });
      }

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const passwordHash = await hashValue(input.value);
        if (passwordHash === expectedHash) {
          setUnlocked({ resetScroll: true });
          return;
        }

        field.classList.add('is-error');
        if (error) error.hidden = false;
        input.select();
      });
    };

    document.querySelectorAll('[data-partnership-password-gate]').forEach(initializeGate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-press-ticker-track')) {
    customElements.define('sb-press-ticker-track', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => this.classList.toggle('is-offscreen', !entry.isIntersecting));
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-reviews-list"]) return;
  try {
    
    (() => {
      const initReviewsList = (root) => {
        if (!root || root.dataset.sbReviewsInit === 'true') return;
        root.dataset.sbReviewsInit = 'true';
        const isPhotoLayout = root.dataset.reviewLayout === 'photos';
        const normalizePhotoUrl = (value) => {
          try {
            const url = new URL(value);
            if (url.protocol !== 'https:' || url.username || url.password) return '';
            url.search = '';
            url.hash = '';
            return url.href;
          } catch (_) { return ''; }
        };
        const excludedPhotos = new Set((root.dataset.photoExclusions || '').split(/\s+/).map(normalizePhotoUrl).filter(Boolean));
        const photoReviews = (reviews) => reviews.map(review => ({ ...review,
          pictures: (review.pictures || []).filter(picture => {
            const url = normalizePhotoUrl(picture);
            return url && !excludedPhotos.has(url);
          }),
        })).filter(review => review.pictures.length > 0);
        const lifecycle = new AbortController();
        const { signal } = lifecycle;
        let medalsObserver;
      const medalsEl = root.querySelector('[data-reviews-medals]');
      if (medalsEl) {
        const syncMedalMasks = () => {
          const visibleMedalTypes = new Set(['tran', 'tops_trend', 'tops']);
          medalsEl.querySelectorAll('.jdgm-medal-wrapper').forEach((wrapper) => {
            const medal = wrapper.querySelector('.jdgm-medal');
            if (medal && !visibleMedalTypes.has(medal.dataset.type)) wrapper.remove();
          });
          const medalStrip = medalsEl.querySelector('.jdgm-medals');
          const medalContainer = medalsEl.querySelector('.jdgm-medals__container');
          if (medalStrip) medalStrip.scrollLeft = 0;
          if (medalContainer) medalContainer.style.removeProperty('width');
          medalsEl.querySelectorAll(".jdgm-medal[data-type='tran'], .jdgm-medal[data-type='tops_trend'], .jdgm-medal[data-type='tops']").forEach((medal) => {
            const wrapper = medal.closest('.jdgm-medal-wrapper');
            const imageWrap = medal.querySelector('.jdgm-medal__image');
            const image = imageWrap?.querySelector('img');
            if (!wrapper || !imageWrap || !image?.src) return;
            const judgeMeDescription = wrapper.dataset.judgeMeDescription
              || wrapper.getAttribute('title')?.trim()
              || image.alt.trim();
            const descriptionSentences = judgeMeDescription.match(/[^.!?]+[.!?]?/g)
              ?.map((sentence) => sentence.trim())
              .filter(Boolean) || [];
            const tooltipLabel = descriptionSentences[1] || descriptionSentences[0] || judgeMeDescription;
            wrapper.removeAttribute('title');
            wrapper.dataset.judgeMeDescription = judgeMeDescription;
            wrapper.dataset.medalType = medal.dataset.type || '';
            wrapper.dataset.sbTooltip = tooltipLabel;
            wrapper.tabIndex = 0;
            if (judgeMeDescription) wrapper.setAttribute('aria-label', judgeMeDescription);
            imageWrap.style.setProperty('--sb-medal-mask', `url("${image.src}")`);
            imageWrap.classList.add('is-sb-monochrome');
          });
        };
        syncMedalMasks();
        medalsObserver = new MutationObserver(syncMedalMasks);
        medalsObserver.observe(medalsEl, { childList: true, subtree: true });
      }
      const starIconUrl = root.dataset.starIconUrl;
      const verifiedTpl = root.querySelector('template[data-verified-icon]');
      const shopLogoTpl = root.querySelector('template[data-shop-logo]');
      const productChevronTpl = root.querySelector('template[data-product-chevron]');
      const locale = document.documentElement.lang || 'en';
      const numberFormat = new Intl.NumberFormat(locale);
      const productRatingFormat = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const languageNames = typeof Intl.DisplayNames === 'function'
        ? new Intl.DisplayNames([locale], { type: 'language' })
        : null;
      const regionNames = typeof Intl.DisplayNames === 'function'
        ? new Intl.DisplayNames([locale], { type: 'region' })
        : null;

      /* Relative time: minutes → hours → days → weeks → months, absolute past a year */
      const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      const dtf = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'short', day: 'numeric' });
      const capFirst = (s) => s.charAt(0).toLocaleUpperCase(locale) + s.slice(1);
      const relTime = (iso, referenceAt = '') => capFirst(relTimeRaw(iso, referenceAt));
      const relTimeRaw = (iso, referenceAt = '') => {
        const timestamp = new Date(iso).getTime();
        if (!Number.isFinite(timestamp)) return '';
        const referenceTimestamp = new Date(referenceAt).getTime();
        const now = Number.isFinite(referenceTimestamp) ? referenceTimestamp : Date.now();
        const s = Math.max(0, (now - timestamp) / 1000);
        if (s < 3600) return rtf.format(-Math.max(1, Math.round(s / 60)), 'minute');
        if (s < 86400) return rtf.format(-Math.round(s / 3600), 'hour');
        if (s < 604800) return rtf.format(-Math.round(s / 86400), 'day');
        if (s < 86400 * 35) return rtf.format(-Math.round(s / 604800), 'week');
        if (s < 86400 * 365) return rtf.format(-Math.round(s / (86400 * 30.44)), 'month');
        return dtf.format(timestamp);
      };

      /* Per-product snapshot generated by scripts/sync-judgeme-review-snapshots.mjs */
      const currentSnapshotUrl = (value) => {
        if (!value) return '';
        const url = new URL(value, window.location.origin);
        // Shopify can retain an older asset_url fingerprint in cached product HTML.
        // A short bucket keeps first-page snapshots current without bypassing CDN caching.
        url.searchParams.set('v', String(Math.floor(Date.now() / 300000)));
        return url.toString();
      };
      const dataUrl = currentSnapshotUrl(root.dataset.reviewsUrl);
      const storeDataUrl = currentSnapshotUrl(root.dataset.storeReviewsUrl);

      const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      const normalizeDuplicateUrlMarkup = (value) => String(value || '').replace(
        /<?\[(https?:\/\/[^\s<>\]]+)>?\]\((https?:\/\/[^\s<>\)]+)>?\)>?/gi,
        (match, labelUrl, targetUrl) => labelUrl === targetUrl ? targetUrl : match
      );
      const normalizeReplyMarkdown = (value) => normalizeDuplicateUrlMarkup(value)
        .replace(/^\s*[*-]\s+/gm, '')
        .replace(/\*\*([^*\n]+)\*\*/g, '$1');
      const linkedTextHtml = (value) => {
        const text = normalizeDuplicateUrlMarkup(value);
        const urlPattern = /https?:\/\/[^\s<>"']+/gi;
        let html = '';
        let cursor = 0;

        text.replace(urlPattern, (match, offset) => {
          let url = match;
          let trailing = '';
          while (/[.,;:!?]$/.test(url)) {
            trailing = url.slice(-1) + trailing;
            url = url.slice(0, -1);
          }
          [['(', ')'], ['[', ']'], ['{', '}']].forEach(([opening, closing]) => {
            while (url.endsWith(closing) && url.split(closing).length > url.split(opening).length) {
              trailing = closing + trailing;
              url = url.slice(0, -1);
            }
          });

          html += esc(text.slice(cursor, offset));
          try {
            const parsedUrl = new URL(url);
            if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
              html += `<a class="sb-reviews-list__text-link" href="${esc(url)}" target="_blank" rel="noopener noreferrer">${esc(url)}</a>${esc(trailing)}`;
            } else {
              html += esc(match);
            }
          } catch (_error) {
            html += esc(match);
          }
          cursor = offset + match.length;
          return match;
        });

        return html + esc(text.slice(cursor));
      };
      const paragraphTextHtml = (value) => String(value || '')
        .replace(/\r\n?/g, '\n')
        .split(/\n+/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean)
        .map((paragraph) => `<span class="sb-reviews-list__text-paragraph">${linkedTextHtml(paragraph)}</span>`)
        .join('');

      const verifiedBuyerHtml = () => {
        const label = root.dataset.verifiedLabel || '';
        const tooltip = root.dataset.verificationTooltip || '';
        const ariaLabel = tooltip ? `${label}. ${tooltip}` : label;
        return `<span class="sb-reviews-list__verified-buyer">
          <span
            class="sb-reviews-list__verified-badge"
            tabindex="0"
            data-sb-tooltip="${esc(tooltip)}"
            aria-label="${esc(ariaLabel)}"
          >${verifiedTpl.innerHTML}</span>
          <span class="sb-reviews-list__verified-label font-caption weight-regular">${esc(label)}</span>
        </span>`;
      };

      const safeProductHref = (value) => {
        try {
          const url = new URL(String(value || ''), window.location.origin);
          const internalHosts = new Set([
            window.location.hostname,
            'soundbrenner.com',
            'www.soundbrenner.com',
            'soundbrenner.cn',
            'www.soundbrenner.cn',
          ]);
          if (!internalHosts.has(url.hostname)) return '#';
          const localeRoot = String(root.dataset.localeRoot || '/').replace(/\/$/, '');
          const hasLocaleRoot = localeRoot && localeRoot !== '/';
          const pathname = hasLocaleRoot && url.pathname !== localeRoot && !url.pathname.startsWith(`${localeRoot}/`)
            ? `${localeRoot}${url.pathname.startsWith('/') ? '' : '/'}${url.pathname}`
            : url.pathname;
          return pathname + url.search + url.hash;
        } catch (_) {
          return '#';
        }
      };

      const languageName = (code) => {
        const normalized = String(code || '').trim();
        if (!normalized || normalized === 'und') return normalized || 'und';
        try {
          return languageNames?.of(normalized) || normalized;
        } catch (_) {
          return normalized;
        }
      };

      const translationStatusHtml = (translation, contentType, showOriginal = false) => {
        if (!translation?.source_language) return '';
        const status = String(root.dataset.translatedFromLabel || '')
          .replace('__LANGUAGE__', languageName(translation.source_language));
        return `
          <div class="sb-reviews-list__translation-status font-caption weight-regular">
            <span>${esc(status)}</span>
            <span aria-hidden="true">·</span>
            <button type="button" class="sb-reviews-list__translation-toggle" data-translation-toggle="${contentType}">
              ${esc(showOriginal ? root.dataset.showTranslationLabel : root.dataset.showOriginalLabel)}
            </button>
          </div>`;
      };

      const reviewerCountryName = (review) => {
        const suppliedName = String(review?.reviewer_country || '').trim();
        const code = String(review?.reviewer_country_code || '').trim().toUpperCase();
        if (/^[A-Z]{2}$/.test(code)) {
          try {
            return regionNames?.of(code) || suppliedName || code;
          } catch (_) {
            return suppliedName || code;
          }
        }
        return suppliedName;
      };

      const reviewMetadataStatusHtml = (review, showOriginal = false) => {
        const segments = [];
        const country = reviewerCountryName(review);
        if (country) {
          const label = String(root.dataset.reviewCountryLabel || '').replace('__COUNTRY__', country);
          segments.push(`<span>${esc(label)}</span>`);
        }
        if (review?.translation?.source_language) {
          const translated = String(root.dataset.translatedFromLabel || '')
            .replace('__LANGUAGE__', languageName(review.translation.source_language));
          segments.push(`<span>${esc(translated)}</span>`);
          segments.push(`<button type="button" class="sb-reviews-list__translation-toggle" data-translation-toggle="review">
            ${esc(showOriginal ? root.dataset.showTranslationLabel : root.dataset.showOriginalLabel)}
          </button>`);
        }
        if (segments.length === 0) return '';
        return `<div class="sb-reviews-list__translation-status font-caption weight-regular">
          ${segments.join('<span aria-hidden="true">·</span>')}
        </div>`;
      };

      const starsHtml = (rating) => {
        const numericRating = Math.max(0, Math.min(5, Number(rating) || 0));
        const ratingLabel = String(root.dataset.ratingLabel || '').replace('__RATING__', numericRating);
        let out = '<span class="sb-reviews-list__card-stars" aria-label="' + esc(ratingLabel) + '">';
        for (let i = 0; i < 5; i++) {
          const fill = Math.max(0, Math.min(1, numericRating - i)) * 100;
          out += '<span class="sb-reviews-list__card-star" style="--sb-star-fill: ' + fill + "%; --sb-star-icon-url: url('" + starIconUrl + "');\"></span>";
        }
        return out + '</span>';
      };

      const reviewPhotosHtml = (r) => {
        if (!Array.isArray(r.pictures) || r.pictures.length === 0) return '';
        const key = reviewKey(r);
        return '<div class="sb-reviews-list__item-photos">' + r.pictures.map((picture, index) => {
          const thumbnailUrl = reviewImageCdnUrl(picture, 320) || picture;
          return `
          <button
            type="button"
            class="sb-reviews-list__item-photo-trigger"
            aria-label="${esc(root.dataset.openMediaModalLabel)}"
            data-review-media-trigger
            data-review-key="${esc(key)}"
            data-review-picture-index="${index}"
            data-review-picture-url="${esc(picture)}"
          >
            <img class="sb-reviews-list__item-photo" src="${esc(thumbnailUrl)}" alt="" width="128" height="128" loading="lazy">
          </button>`;
        }).join('') + '</div>';
      };

      const productCardHtml = (r) => {
        if (!isShopScope || reviewType !== 'product' || !r.product_url) return '';
        const handle = r.product_handle || String(r.product_url).split('/').filter(Boolean).pop() || '';
        if (!handle) return '';
        const count = Math.max(0, Number(r.product_review_count) || 0);
        const rating = Math.max(0, Math.min(5, Number(r.product_average_rating) || 0));
        const countLabel = String(root.dataset.productReviewsLabel || '').replace('__COUNT__', numberFormat.format(count));
        return `
          <a class="sb-reviews-list__product-card" href="${esc(safeProductHref(r.product_url))}" target="_blank" rel="noopener noreferrer" data-product-card data-product-handle="${esc(handle)}">
            <span class="sb-reviews-list__product-card-media" data-product-card-media aria-hidden="true">
              <img class="sb-reviews-list__product-card-image" alt="" width="64" height="64" loading="lazy" data-product-card-image hidden>
            </span>
            <span class="sb-reviews-list__product-card-copy">
              <span class="sb-reviews-list__product-card-title font-caption weight-bold" data-product-card-title>${esc(r.product_title || '')}</span>
              <span class="sb-reviews-list__product-card-meta font-caption weight-regular">
                <span>${esc(productRatingFormat.format(rating))}</span>
                <span class="sb-reviews-list__product-card-star" style="--sb-star-icon-url: url('${starIconUrl}');" aria-hidden="true"></span>
                <span>${esc(countLabel)}</span>
              </span>
            </span>
            ${productChevronTpl.innerHTML}
          </a>`;
      };

      const customQuestionPercent = (question) => {
        const suppliedPercent = Number(question.percent);
        if (Number.isFinite(suppliedPercent)) return Math.max(0, Math.min(100, suppliedPercent));
        const value = Number(question.value ?? question.answer ?? question.average);
        const min = Number(question.min);
        const max = Number(question.max);
        if (!Number.isFinite(value) || !Number.isFinite(min) || !Number.isFinite(max) || max <= min) return 0;
        return Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));
      };

      const customQuestionProgressWidth = (percent) => {
        const clampedPercent = Math.max(0, Math.min(100, Number(percent) || 0));
        const dotRadiusOffset = 6 - (clampedPercent * 0.12);
        const operator = dotRadiusOffset < 0 ? '-' : '+';
        return `calc(${clampedPercent}% ${operator} ${Math.abs(dotRadiusOffset).toFixed(2)}px)`;
      };

      const customQuestionDotTarget = (percent) => {
        const clampedPercent = Math.max(0, Math.min(100, Number(percent) || 0));
        const dotRadiusOffset = 6 - (clampedPercent * 0.12);
        const operator = dotRadiusOffset < 0 ? '-' : '+';
        return `calc(${clampedPercent}cqi ${operator} ${Math.abs(dotRadiusOffset).toFixed(2)}px)`;
      };

      const customQuestionTitle = (question) => {
        const title = String(question?.title || '').trim();
        const localizedTitles = {
          'sound quality': root.dataset.customQuestionSoundQualityLabel,
          comfort: root.dataset.customQuestionComfortLabel,
        };
        return localizedTitles[title.toLowerCase()] || title;
      };

      const customQuestionsHtml = (r) => {
        const questions = Array.isArray(r.custom_questions) ? r.custom_questions : [];
        const validQuestions = questions.filter((question) => question && question.title).slice(0, 2);
        if (validQuestions.length === 0) return '';
        return '<div class="sb-reviews-list__item-custom-questions">' + validQuestions.map((question) => {
          const percent = customQuestionPercent(question);
          return `
          <div class="sb-reviews-list__item-custom-question">
            <p class="sb-reviews-list__item-custom-question-title font-caption weight-bold">${esc(customQuestionTitle(question))}</p>
            <div class="sb-reviews-list__item-custom-question-bar" aria-hidden="true">
              <span
                class="sb-reviews-list__item-custom-question-fill"
                data-sb-progress-fill
                style="width: ${customQuestionProgressWidth(percent)};"
              ></span>
              <span
                class="sb-reviews-list__item-custom-question-dot"
                data-sb-progress-dot
                style="--sb-progress-dot-target: ${customQuestionDotTarget(percent)};"
              ></span>
            </div>
            <div class="sb-reviews-list__item-custom-question-labels font-caption weight-regular">
              <span>${esc(root.dataset.customQuestionLowLabel || '')}</span>
              <span>${esc(root.dataset.customQuestionHighLabel || '')}</span>
            </div>
          </div>`;
        }).join('') + '</div>';
      };

      const shopBadgeHtml = (r) => r.source === 'shop-app'
        ? '<div class="sb-reviews-list__item-badges"><span class="sb-reviews-list__shop-badge font-caption2 weight-medium"><span>' + esc(root.dataset.verifiedByLabel) + '</span>' + shopLogoTpl.innerHTML + '</span></div>'
        : '';

      const replyHtml = (r, showOriginal = false) => {
        if (!r.reply) return '';
        const replyBody = showOriginal ? r.reply.original_body : r.reply.body;
        const replyDate = r.reply.relative_date || (r.reply.created_at ? relTimeRaw(r.reply.created_at, snapshot.reference_at) : '');
        return '<div class="sb-reviews-list__item-reply">' +
          '<p class="sb-reviews-list__item-reply-head font-caption weight-regular">' + esc(r.reply.created_at ? root.dataset.repliedLabel.replace('__TIME__', replyDate) : root.dataset.repliedWithoutTimeLabel) + '</p>' +
          '<div class="sb-reviews-list__item-reply-body">' +
            '<p class="sb-reviews-list__item-reply-copy font-caption weight-regular" data-reply-body>' + paragraphTextHtml(normalizeReplyMarkdown(replyBody)) + '</p>' +
            translationStatusHtml(r.reply.translation, 'reply', showOriginal) +
          '</div>' +
        '</div>';
      };

      const reviewContentHtml = (r, {
        includePhotos = true,
        includeProduct = true,
        showOriginalReview = false,
        showOriginalReply = false,
      } = {}) => {
        const title = showOriginalReview ? r.original_title : r.title;
        const body = showOriginalReview ? r.original_body : r.body;
        return `
          ${(r.title || r.original_title) ? '<h3 class="sb-reviews-list__item-title font-caption weight-bold" data-review-title' + (title ? '' : ' hidden') + '>' + esc(title || '') + '</h3>' : ''}
          <p class="sb-reviews-list__item-body font-caption weight-regular" data-review-body>${paragraphTextHtml(body)}</p>
          ${reviewMetadataStatusHtml(r, showOriginalReview)}
          ${includePhotos ? reviewPhotosHtml(r) : ''}
          ${shopBadgeHtml(r)}
          ${includeProduct ? productCardHtml(r) : ''}
          ${customQuestionsHtml(r)}
          ${replyHtml(r, showOriginalReply)}`;
      };

      const photoButtonHtml = (r, index, cover = false) => {
        const picture = r.pictures[index];
        const src = reviewImageCdnUrl(picture, cover ? 750 : 128) || picture;
        const srcset = cover ? [360, 750, 1100].map(width => `${reviewImageCdnUrl(picture, width) || picture} ${width}w`).join(', ') : [64, 128, 192].map((width, index) => `${reviewImageCdnUrl(picture, width) || picture} ${index + 1}x`).join(', ');
        const alt = (root.dataset.photoAltLabel || '').replace('__REVIEWER__', r.reviewer || root.dataset.anonymousLabel);
        return `<button type="button" class="sb-reviews-list__photo-${cover ? 'cover' : 'thumbnail'}" data-review-media-trigger data-review-key="${esc(reviewKey(r))}" data-review-picture-index="${index}" data-review-picture-url="${esc(picture)}" aria-label="${esc(root.dataset.openMediaModalLabel)}">
          <img src="${esc(src)}" srcset="${esc(srcset)}" ${cover ? 'sizes="(min-width: 990px) 300px, (min-width: 750px) calc((100vw - 96px) / 2), calc((100vw - 48px) / 2)"' : ''} width="${cover ? 320 : 64}" height="${cover ? 427 : 64}" loading="lazy" alt="${esc(alt)}"></button>`;
      };
      // Keep normal reviews complete; the existing image modal retains the full body.
      const photoBodyText = body => {
        const text = Array.from(String(body || ''));
        return text.length > 1000 ? text.slice(0, 997).join('') + '...' : text.join('');
      };
      const photoCardHtml = (r) => `<li class="sb-reviews-list__item sb-reviews-list__photo-card" data-review-key="${esc(reviewKey(r))}">
        ${photoButtonHtml(r, 0, true)}<div class="sb-reviews-list__photo-copy">
          <div class="sb-reviews-list__photo-meta"><div class="sb-reviews-list__item-author-row"><span class="sb-reviews-list__item-author font-body weight-regular">${esc(r.reviewer || root.dataset.anonymousLabel)}</span>${r.verified ? `<span class="sb-reviews-list__photo-verified">${verifiedTpl.innerHTML}<span>${esc(root.dataset.photoVerifiedLabel)}</span></span>` : ''}</div>
          <time class="sb-reviews-list__item-date font-caption weight-regular" datetime="${esc(r.created_at)}">${esc(r.relative_date || relTime(r.created_at, snapshot.reference_at))}</time></div>
          ${starsHtml(r.rating)}<p class="sb-reviews-list__item-body font-caption weight-regular" data-review-body>${paragraphTextHtml(photoBodyText(r.body))}</p>
          ${r.pictures.length > 1 ? `<div class="sb-reviews-list__photo-thumbnails">${r.pictures.slice(1).map((_, index) => photoButtonHtml(r, index + 1)).join('')}</div>` : ''}
        </div></li>`;
      const cardHtml = (r) => isPhotoLayout ? photoCardHtml(r) : `
        <li class="sb-reviews-list__item" data-review-key="${esc(reviewKey(r))}" data-sb-progress-root data-sb-motion="reveal" data-sb-motion-item data-sb-motion-initial="reveal">
          <div class="sb-reviews-list__item-top">
            ${starsHtml(r.rating)}
            <span class="sb-reviews-list__item-date font-caption weight-regular">${esc(r.relative_date || relTime(r.created_at, snapshot.reference_at))}</span>
          </div>
          <div
            class="sb-reviews-list__item-author-row"
            ${r.verified && root.dataset.verificationTooltip ? `data-verification-tooltip="${esc(root.dataset.verificationTooltip)}"` : ''}
          >
            <span class="sb-reviews-list__item-author font-caption weight-regular">${esc(r.reviewer)}</span>
            ${r.verified ? verifiedBuyerHtml() : ''}
          </div>
          ${reviewContentHtml(r)}
        </li>`;

        /* Data sources: localized Shopify-CDN snapshots are the default;
           the Worker proxy serves relevance ordering, search, filter, and
           pagination interactions. Both sources share the card renderer. */
        const PAGE_SIZE = isPhotoLayout ? (window.matchMedia('(max-width: 749px)').matches ? 6 : 12) : 5;
        const REQUEST_PAGE_SIZE = isPhotoLayout ? 20 : PAGE_SIZE;
        const proxyUrl = root.dataset.proxyUrl || '';
        const isShopScope = root.dataset.scope === 'shop';
        const itemsEl = root.querySelector('[data-reviews-items]');
        // Keep the first row in review order, then balance each new batch by height.
        // Retain existing placements when revealing more; reflow on width/content changes.
        let photoMasonryWidth = 0;
        let photoMasonryPlacements = new WeakMap();
        const layoutPhotoMasonry = () => {
          const cards = Array.from(itemsEl.children);
          const width = itemsEl.clientWidth;
          if (width !== photoMasonryWidth) {
            // Drop desktop column assignments before measuring a narrower grid.
            cards.forEach(card => {
              card.style.removeProperty('grid-column-start');
              card.style.removeProperty('grid-row-start');
            });
          }
          const heights = cards.map(card => card.offsetHeight + 24);
          const columns = getComputedStyle(itemsEl).gridTemplateColumns.split(' ').length;
          const preserve = width === photoMasonryWidth && cards.every((card, index) => {
            const previous = photoMasonryPlacements.get(card);
            return !previous || previous.height === heights[index];
          });
          const bottoms = Array(columns).fill(0);
          const placements = new WeakMap();
          const pending = [];
          const place = (entry, column, top = bottoms[column]) => {
            const placement = { column, top, height: entry.height };
            placements.set(entry.card, placement);
            bottoms[column] = Math.max(bottoms[column], top + entry.height);
          };
          cards.forEach((card, index) => {
            const entry = { card, height: heights[index], index };
            const previous = preserve && photoMasonryPlacements.get(card);
            if (previous) place(entry, previous.column, previous.top);
            else pending.push(entry);
          });
          if (bottoms.every(bottom => bottom === 0)) {
            pending.splice(0, columns).forEach((entry, column) => place(entry, column));
          }
          // Taller reviews go first so shorter ones can fill the remaining gaps.
          pending.sort((a, b) => b.height - a.height || a.index - b.index)
            .forEach(entry => place(entry, bottoms.indexOf(Math.min(...bottoms))));
          itemsEl.dataset.photoMasonry = 'true';
          cards.forEach(card => {
            const { column, top, height } = placements.get(card);
            card.style.gridColumnStart = String(column + 1);
            card.style.gridRowStart = String(top + 1);
            card.style.gridRowEnd = `span ${height}`;
          });
          photoMasonryWidth = width;
          photoMasonryPlacements = placements;
        };
        let photoMasonryFrame = 0;
        const photoMasonryObserver = isPhotoLayout && typeof ResizeObserver === 'function'
          ? new ResizeObserver(() => {
              if (photoMasonryFrame) return;
              photoMasonryFrame = requestAnimationFrame(() => {
                photoMasonryFrame = 0;
                layoutPhotoMasonry();
              });
            })
          : null;
        const syncPhotoMasonry = () => {
          if (!photoMasonryObserver) return;
          photoMasonryObserver.disconnect();
          layoutPhotoMasonry();
          Array.from(itemsEl.children).forEach(card => photoMasonryObserver.observe(card));
        };
        const distEl = root.querySelector('[data-reviews-dist]');
        const textWithBreaks = (element) => {
          if (!(element instanceof HTMLElement)) return '';
          const copy = element.cloneNode(true);
          copy.querySelectorAll('.sb-reviews-list__text-paragraph + .sb-reviews-list__text-paragraph').forEach((paragraph) => {
            paragraph.before('\n');
          });
          copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
          return String(copy.textContent || '').trim();
        };
        const embeddedSnapshots = root.querySelector('[data-review-snapshots]');
        let savedSnapshots = null;
        if (embeddedSnapshots) {
          try { savedSnapshots = JSON.parse(embeddedSnapshots.content?.textContent || embeddedSnapshots.textContent); } catch (_) { /* Use the rendered fallback. */ }
        }
        const serverReviewElements = Array.from(itemsEl.querySelectorAll('[data-server-review]'));
        const ssrData = serverReviewElements.length > 0
          ? {
              count: Number(root.dataset.serverReviewCount) || serverReviewElements.length,
              distribution: Object.fromEntries(
                Array.from(distEl.querySelectorAll('[data-dist-star]')).map((row) => [
                  row.dataset.distStar,
                  Number(row.querySelector('.sb-reviews-list__dist-pct')?.textContent?.replace('%', '')) || 0,
                ])
              ),
              type_counts: { product: Number(root.dataset.serverReviewCount) || serverReviewElements.length },
              custom_questions_summary: [],
              reviews: serverReviewElements.map((item) => {
                const replyBody = item.querySelector('[data-reply-body]');
                return {
                  id: item.dataset.reviewKey,
                  rating: Number(item.dataset.reviewRating) || 0,
                  title: textWithBreaks(item.querySelector('[data-review-title]')),
                  body: textWithBreaks(item.querySelector('[data-review-body]')),
                  original_title: '',
                  original_body: '',
                  translation: null,
                  reviewer: item.dataset.reviewAuthor || root.dataset.anonymousLabel,
                  reviewer_country: item.dataset.reviewCountry || '',
                  reviewer_country_code: item.dataset.reviewCountryCode || '',
                  created_at: item.dataset.reviewCreatedAt || '',
                  verified: item.dataset.reviewVerified === 'true',
                  source: item.dataset.reviewSource || '',
                  pictures: Array.from(item.querySelectorAll('[data-review-media-trigger]'))
                    .map((trigger) => trigger.dataset.reviewPictureUrl || trigger.querySelector('.sb-reviews-list__item-photo')?.currentSrc || trigger.querySelector('.sb-reviews-list__item-photo')?.src)
                    .filter(Boolean),
                  reply: replyBody
                    ? { body: textWithBreaks(replyBody), original_body: '', created_at: '', translation: null }
                    : null,
                  product_title: '',
                  product_handle: '',
                  product_url: '',
                  product_review_count: Number(root.dataset.serverReviewCount) || 0,
                  product_average_rating: 0,
                  custom_questions: Array.from(item.querySelectorAll('[data-review-custom-question]')).map((question) => ({
                    title: question.dataset.questionTitle || '',
                    value: Number(question.dataset.questionValue),
                    min: Number(question.dataset.questionMin),
                    max: Number(question.dataset.questionMax),
                    percent: Number(question.dataset.questionPercent),
                    min_label: question.dataset.questionMinLabel || '',
                    max_label: question.dataset.questionMaxLabel || '',
                  })),
                };
              }),
            }
          : null;
        const moreButton = root.querySelector('[data-reviews-more]');
        const searchInput = root.querySelector('[data-reviews-search]');
        const filterSelect = root.querySelector('[data-reviews-filter]');
        const filterValueEl = root.querySelector('[data-reviews-filter-label]');
        const typeTabs = Array.from(root.querySelectorAll('[data-review-type]'));
        const productTypeCount = root.querySelector('[data-review-type-count="product"]');
        const storeTypeCount = root.querySelector('[data-review-type-count="store"]');
        const resultCountEl = root.querySelector('[data-reviews-result-count]');
        const emptyEl = root.querySelector('[data-reviews-empty]');
        const clearButton = root.querySelector('[data-reviews-clear]');
        const footerEl = root.querySelector('.sb-reviews-list__footer');
        const customSummaryEl = root.querySelector('[data-reviews-custom-summary]');
        const mediaModal = root.querySelector('[data-review-media-modal]');
        const mediaModalImage = root.querySelector('[data-review-media-modal-image]');
        const mediaModalStars = root.querySelector('[data-review-media-modal-stars]');
        const mediaModalDate = root.querySelector('[data-review-media-modal-date]');
        const mediaModalAuthor = root.querySelector('[data-review-media-modal-author]');
        const mediaModalVerification = root.querySelector('[data-review-media-modal-verification]');
        const mediaModalCopy = root.querySelector('[data-review-media-modal-copy]');

        const initializedProgressRoots = new WeakSet();
        const initializeSummaryProgress = () => {
          const progressRoots = [distEl, customSummaryEl].filter((element) => element instanceof HTMLElement);
          progressRoots.forEach((element) => {
            if (initializedProgressRoots.has(element) || !element.querySelector('[data-sb-progress-fill]')) return;
            initializedProgressRoots.add(element);
            element.dispatchEvent(new CustomEvent('sb:motion:reset', { bubbles: true }));
          });
        };

        const renderCustomSummary = (questions) => {
          if (!customSummaryEl) return;
          const validQuestions = Array.isArray(questions)
            ? questions.filter((question) => question && question.title).slice(0, 2)
            : [];
          customSummaryEl.hidden = validQuestions.length === 0;
          customSummaryEl.innerHTML = validQuestions.map((question, index) => {
            const average = Number(question.average);
            const min = Number(question.min);
            const max = Number(question.max);
            const suppliedPercent = Number(question.percent);
            const numericPercent = Number.isFinite(suppliedPercent)
              ? suppliedPercent
              : (Number.isFinite(average) && Number.isFinite(min) && Number.isFinite(max) && max > min
                ? ((average - min) / (max - min)) * 100
                : 0);
            const percent = Math.max(0, Math.min(100, numericPercent));
            const divider = index === 1 ? '<span class="sb-reviews-list__custom-summary-divider" aria-hidden="true"></span>' : '';
            return `${divider}
              <div class="sb-reviews-list__custom-question">
                <h3 class="sb-reviews-list__custom-question-title font-body weight-bold">${esc(customQuestionTitle(question))}</h3>
                <div class="sb-reviews-list__custom-question-bar" aria-hidden="true">
                  <span class="sb-reviews-list__custom-question-fill" data-sb-progress-fill style="width: ${customQuestionProgressWidth(percent)};"></span>
                  <span class="sb-reviews-list__custom-question-dot" data-sb-progress-dot style="--sb-progress-dot-target: ${customQuestionDotTarget(percent)};"></span>
                </div>
                <div class="sb-reviews-list__custom-question-labels font-body weight-regular">
                  <span>${esc(root.dataset.customQuestionLowLabel || '')}</span>
                  <span>${esc(root.dataset.customQuestionHighLabel || '')}</span>
                </div>
              </div>`;
          }).join('');
        };

        renderCustomSummary([]);

        let snapshot = { count: 0, reviews: [] };
        const snapshots = { product: null, store: null };
        let list = [];
        let totalCount = 0;
        let visibleCount = PAGE_SIZE;
        let reviewType = 'product';
        let filterRating = 0;
        let photosOnly = isPhotoLayout;
        let sortChoice = null;
        let displayedSort = root.dataset.defaultSort || 'recent';
        let query = '';
        let fetchSeq = 0;
        let nextPage = 2;
        let renderedKeys = savedSnapshots?.product ? serverReviewElements.map((item) => item.dataset.reviewKey) : [];
        const productMetaCache = new Map();
        const reviewStore = new Map();
        let lastMediaTrigger = null;
        let lastPointerMediaTrigger = null;
        let mediaModalViewportFrame = 0;
        let searchDebounce = 0;

        const usesMobileDocumentLayer = () => window.matchMedia('(max-width: 749px)').matches;

        const trapMediaModalFocus = (event) => {
          if (event.key !== 'Tab' || !usesMobileDocumentLayer() || !(mediaModal instanceof HTMLDialogElement)) return;
          const controls = Array.from(mediaModal.querySelectorAll('button:not([hidden]):not([disabled]), [href], [tabindex]:not([tabindex="-1"])'))
            .filter((control) => control instanceof HTMLElement && control.getClientRects().length > 0);
          if (!controls.length) {
            event.preventDefault();
            mediaModal.focus({ preventScroll: true });
            return;
          }
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus({ preventScroll: true });
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus({ preventScroll: true });
          }
        };

        const ensureMediaModalBackdrop = () => {
          let backdrop = document.querySelector('[data-review-media-modal-backdrop]');
          if (backdrop instanceof HTMLElement) return backdrop;
          backdrop = document.createElement('div');
          backdrop.className = 'sb-modal-page-backdrop sb-modal-page-backdrop--review-media';
          backdrop.dataset.reviewMediaModalBackdrop = '';
          backdrop.setAttribute('aria-hidden', 'true');
          document.body.prepend(backdrop);
          return backdrop;
        };

        const updateMediaModalViewport = () => {
          mediaModalViewportFrame = 0;
          if (!document.documentElement.classList.contains('sb-review-media-modal-open')) return;
          const viewport = window.visualViewport;
          const height = Math.ceil(viewport?.height || window.innerHeight || document.documentElement.clientHeight || 0);
          const width = Math.ceil(viewport?.width || window.innerWidth || document.documentElement.clientWidth || 0);
          const top = Math.floor(viewport?.offsetTop || 0);
          const left = Math.floor(viewport?.offsetLeft || 0);
          const measureSpace = (token, fallback) => {
            const probe = document.createElement('span');
            probe.style.cssText = `height:0;position:absolute;visibility:hidden;width:var(${token}, ${fallback}px);`;
            document.body.appendChild(probe);
            const measured = probe.getBoundingClientRect().width;
            probe.remove();
            return measured || fallback;
          };
          const horizontalPadding = measureSpace('--sb-space-30', 30);
          const verticalPadding = measureSpace('--sb-space-96', 96);
          const availableWidth = Math.max(0, width - horizontalPadding * 2);
          const availableHeight = Math.max(0, height - verticalPadding * 2);
          const scale = width <= 749
            ? 1
            : Math.max(0, Math.min(1, availableWidth / 960, availableHeight / 640));
          const modalWidth = 960 * scale;
          const modalHeight = 640 * scale;
          const html = document.documentElement;
          html.style.setProperty('--sb-review-media-modal-viewport-height', `${height}px`);
          html.style.setProperty('--sb-review-media-modal-viewport-width', `${width}px`);
          html.style.setProperty('--sb-review-media-modal-viewport-top', `${top}px`);
          html.style.setProperty('--sb-review-media-modal-viewport-left', `${left}px`);
          html.style.setProperty('--sb-review-media-modal-height', `${modalHeight}px`);
          html.style.setProperty('--sb-review-media-modal-width', `${modalWidth}px`);
        };

        const requestMediaModalViewportUpdate = () => {
          if (!document.documentElement.classList.contains('sb-review-media-modal-open') || mediaModalViewportFrame) return;
          mediaModalViewportFrame = window.requestAnimationFrame(updateMediaModalViewport);
        };

        const closeMediaModal = () => {
          if (!(mediaModal instanceof HTMLDialogElement) || !mediaModal.open) return;
          mediaModal.close();
          if (lastPointerMediaTrigger instanceof HTMLElement && document.activeElement === lastPointerMediaTrigger) {
            lastPointerMediaTrigger.blur();
          }
          try {
            const selection = window.getSelection();
            if (selection && !selection.isCollapsed) selection.removeAllRanges();
          } catch (_) {}
          document.documentElement.classList.remove('sb-review-media-modal-open');
          document.querySelector('[data-review-media-modal-backdrop]')?.remove();
          if (mediaModalViewportFrame) {
            window.cancelAnimationFrame(mediaModalViewportFrame);
            mediaModalViewportFrame = 0;
          }
          if (lastMediaTrigger instanceof HTMLElement && document.contains(lastMediaTrigger)) {
            lastMediaTrigger.focus({ preventScroll: true });
          }
          lastMediaTrigger = null;
          lastPointerMediaTrigger = null;
          mediaModal.removeAttribute('data-pointer-open');
          mediaModal.removeAttribute('aria-modal');
        };

        // Shared ladder tiers (docs/image-size-ladder.md) truncated at 1500:
        // the Judge.me image proxy upscales past the source, and its largest
        // non-upscaled rendition is 1600px, so 1500 is the safe top tier. It
        // covers 2x on the 640px desktop slot and 3x on phone widths.
        const REVIEW_IMAGE_LADDER = [360, 750, 1100, 1500];
        const reviewImageCdnUrl = (value, width) => {
          try {
            const url = new URL(String(value || ''), window.location.origin);
            if (url.hostname !== 'review-images.judgeme.com' && url.hostname !== 'review-images.judge.me') return null;
            url.searchParams.set('quality', '80');
            url.searchParams.set('width', String(width));
            return url.toString();
          } catch (_) {
            return null;
          }
        };

        const openMediaModal = (trigger, { keyboardInitiated = false } = {}) => {
          if (!(mediaModal instanceof HTMLDialogElement) || !(trigger instanceof HTMLElement)) return;
          if (!(mediaModalStars instanceof HTMLElement) || !(mediaModalDate instanceof HTMLElement)) return;
          if (!(mediaModalAuthor instanceof HTMLElement) || !(mediaModalVerification instanceof HTMLElement)) return;
          if (!(mediaModalCopy instanceof HTMLElement)) return;
          const review = reviewStore.get(trigger.dataset.reviewKey || '');
          const pictureIndex = Number(trigger.dataset.reviewPictureIndex) || 0;
          const picture = review?.pictures?.[pictureIndex];
          if (!review || !picture || !(mediaModalImage instanceof HTMLImageElement)) return;

          const fallbackUrl = reviewImageCdnUrl(picture, 1100);
          const imageUrl = fallbackUrl || String(picture || '');
          mediaModalImage.dataset.requestedSrc = imageUrl;
          mediaModalImage.classList.remove('is-loaded');
          mediaModalImage.onload = () => {
            if (mediaModalImage.dataset.requestedSrc === imageUrl) mediaModalImage.classList.add('is-loaded');
          };
          mediaModalImage.onerror = () => {
            if (mediaModalImage.dataset.requestedSrc === imageUrl) mediaModalImage.classList.remove('is-loaded');
          };
          if (fallbackUrl) {
            mediaModalImage.srcset = REVIEW_IMAGE_LADDER
              .map((w) => `${reviewImageCdnUrl(picture, w)} ${w}w`)
              .join(', ');
          } else {
            mediaModalImage.removeAttribute('srcset');
          }
          mediaModalImage.src = imageUrl;
          if (mediaModalImage.complete && mediaModalImage.naturalWidth > 0) {
            mediaModalImage.classList.add('is-loaded');
          }
          mediaModalStars.innerHTML = starsHtml(review.rating);
          mediaModalDate.textContent = review.relative_date || relTime(review.created_at, snapshot.reference_at);
          mediaModalDate.setAttribute('datetime', review.created_at || '');
          mediaModalAuthor.textContent = review.reviewer || root.dataset.anonymousLabel;
          mediaModalVerification.innerHTML = review.verified ? verifiedBuyerHtml() : '';
          mediaModalCopy.dataset.reviewKey = reviewKey(review);
          delete mediaModalCopy.dataset.showOriginalReview;
          delete mediaModalCopy.dataset.showOriginalReply;
          mediaModalCopy.innerHTML = reviewContentHtml(review, { includePhotos: false, includeProduct: false });

          lastMediaTrigger = keyboardInitiated ? trigger : null;
          lastPointerMediaTrigger = keyboardInitiated ? null : trigger;
          document.documentElement.classList.add('sb-review-media-modal-open');
          ensureMediaModalBackdrop();
          updateMediaModalViewport();
          mediaModal.toggleAttribute('data-pointer-open', !keyboardInitiated);
          if (usesMobileDocumentLayer()) {
            mediaModal.setAttribute('aria-modal', 'true');
            mediaModal.show();
          } else {
            mediaModal.removeAttribute('aria-modal');
            mediaModal.showModal();
          }
          mediaModalCopy.dispatchEvent(new CustomEvent('sb:motion:reset', { bubbles: true }));
          root.querySelector('[data-review-media-modal-close]')?.focus({ preventScroll: true });
        };

        const bindReviewMediaTriggers = () => {
          itemsEl.querySelectorAll('[data-review-media-trigger]:not([data-review-media-trigger-bound])').forEach((trigger) => {
            trigger.dataset.reviewMediaTriggerBound = 'true';
            trigger.addEventListener('click', (event) => {
              openMediaModal(trigger, { keyboardInitiated: event.detail === 0 });
            });
          });
        };

        const hasFilter = () => filterRating > 0 || (photosOnly && !isPhotoLayout) || query !== '';
        const effectiveSort = () => {
          if (!proxyUrl || filterRating || photosOnly) return 'recent';
          if (sortChoice) return sortChoice;
          return snapshots[reviewType]?.sort_mode || 'recent';
        };

        const proxyFetch = (page, perPage, { sort, type, unfiltered = false } = {}) => {
          const u = new URL(proxyUrl);
          if (isShopScope) u.searchParams.set('scope', 'shop');
          else u.searchParams.set('product_id', root.dataset.productId);
          u.searchParams.set('review_type', type || reviewType);
          u.searchParams.set('response_version', '2');
          u.searchParams.set('locale', root.dataset.locale || locale);
          u.searchParams.set('page', page);
          u.searchParams.set('per_page', perPage);
          u.searchParams.set('sort', sort || effectiveSort());
          const datasetId = snapshots.product?.dataset_id;
          if (datasetId) u.searchParams.set('dataset', datasetId);
          u.searchParams.set('sort_version', '2');
          if (!unfiltered && filterRating) u.searchParams.set('rating', filterRating);
          if (isPhotoLayout || (!unfiltered && photosOnly)) u.searchParams.set('photos', '1');
          if (!unfiltered && query) u.searchParams.set('q', query);
          return fetch(u, { signal }).then((res) => {
            if (!res.ok) throw new Error(res.status);
            return res.json();
          }).then(data => {
            if (datasetId && data.dataset_id !== datasetId) throw new Error('Review dataset mismatch');
            return data;
          });
        };

        const canonicalReviewIdentityText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

        const reviewIdentity = (review) => {
          const timestamp = Date.parse(review?.created_at || '');
          const second = Number.isFinite(timestamp) ? Math.floor(timestamp / 1000) : review?.created_at || '';
          const canonicalReviewer = canonicalReviewIdentityText(review?.reviewer);
          const canonicalTitle = canonicalReviewIdentityText(review?.original_title || review?.title);
          const canonicalBody = canonicalReviewIdentityText(review?.original_body || review?.body);
          return `${second}|${review?.rating || ''}|${canonicalReviewer}|${canonicalTitle}|${canonicalBody}`;
        };

        /* On PDPs every card is this page's product — drop the product line */
        const normalize = (r) => {
          const snapshotReview = snapshot.reviews.find((review) => reviewIdentity(review) === reviewIdentity(r));
          const customQuestions = Array.isArray(r.custom_questions) && r.custom_questions.length > 0
            ? r.custom_questions
            : snapshotReview?.custom_questions || [];
          const normalized = Object.assign({}, r, {
            reviewer: r.reviewer || root.dataset.anonymousLabel,
            relative_date: r.relative_date || snapshotReview?.relative_date || '',
            reply: r.reply && snapshotReview?.reply
              ? Object.assign({}, r.reply, { relative_date: r.reply.relative_date || snapshotReview.reply.relative_date || '' })
              : r.reply,
            custom_questions: customQuestions,
          });
          return isShopScope && reviewType === 'product'
            ? normalized
            : Object.assign(normalized, { product_title: '', product_url: '' });
        };

        const reviewKey = (review) => String(review.id || `${review.created_at}|${review.reviewer}|${review.product_url || ''}`);

        const updateTypeCounts = () => {
          const productCount = Number(snapshots.product?.count) || 0;
          const storeCount = Number(snapshots.store?.count)
            || Number(snapshots.product?.type_counts?.store)
            || 0;
          if (productTypeCount) productTypeCount.textContent = numberFormat.format(productCount);
          if (storeTypeCount) storeTypeCount.textContent = numberFormat.format(storeCount);
        };

        const syncReviewTypeUi = () => {
          typeTabs.forEach((tab) => {
            const active = tab.dataset.reviewType === reviewType;
            tab.classList.toggle('sb-reviews-list__tab--active', active);
            tab.setAttribute('aria-selected', String(active));
          });
        };

        const fetchProductMeta = (handle) => {
          if (!productMetaCache.has(handle)) {
            const localeRoot = String(root.dataset.localeRoot || '/').replace(/\/$/, '');
            const productJsonUrl = `${localeRoot}/products/${encodeURIComponent(handle)}.js`;
            productMetaCache.set(handle, fetch(productJsonUrl, { credentials: 'same-origin', signal })
              .then((res) => {
                if (!res.ok) throw new Error(res.status);
                return res.json();
              })
              .catch(() => null));
          }
          return productMetaCache.get(handle);
        };

        const hydrateProductCards = () => {
          itemsEl.querySelectorAll('[data-product-card]:not([data-product-hydrated])').forEach((card) => {
            card.setAttribute('data-product-hydrated', 'true');
            const handle = card.dataset.productHandle;
            fetchProductMeta(handle).then((productData) => {
              if (!productData || !card.isConnected) return;
              const titleEl = card.querySelector('[data-product-card-title]');
              const mediaEl = card.querySelector('[data-product-card-media]');
              const imageEl = card.querySelector('[data-product-card-image]');
              if (titleEl && productData.title) titleEl.textContent = productData.title;
              const imageSource = productData.featured_image || (productData.images || [])[0];
              if (!mediaEl || !imageEl || !imageSource) {
                return;
              }
              const normalizedImageSource = String(imageSource).startsWith('//') ? `https:${imageSource}` : imageSource;
              const imageUrl = new URL(normalizedImageSource, window.location.origin);
              imageUrl.searchParams.set('width', '128');
              const preload = new Image();
              preload.onload = () => {
                if (!card.isConnected) return;
                imageEl.src = imageUrl.toString();
                imageEl.hidden = false;
              };
              preload.onerror = () => {
                imageEl.hidden = true;
              };
              preload.src = imageUrl.toString();
            });
          });
        };

        const render = ({ revealNewItems = false } = {}) => {
          const visibleReviews = list.slice(0, visibleCount);
          const visibleKeys = visibleReviews.map(reviewKey);
          reviewStore.clear();
          visibleReviews.forEach((review) => reviewStore.set(reviewKey(review), review));
          const canAppend = renderedKeys.length > 0
            && renderedKeys.length <= visibleKeys.length
            && renderedKeys.every((key, index) => key === visibleKeys[index]);

          if (canAppend) {
            itemsEl.insertAdjacentHTML('beforeend', visibleReviews.slice(renderedKeys.length).map(cardHtml).join(''));
          } else {
            itemsEl.innerHTML = visibleReviews.map(cardHtml).join('');
          }
          renderedKeys = visibleKeys;
          hydrateProductCards();
          bindReviewMediaTriggers();

          Array.from(itemsEl.children).forEach((item) => item.removeAttribute('data-sb-motion-link'));
          footerEl?.removeAttribute('data-sb-motion-linked-state');
          const lastVisibleItem = itemsEl.lastElementChild;
          if (!isPhotoLayout && revealNewItems && lastVisibleItem) {
            lastVisibleItem.setAttribute('data-sb-motion-link', 'reviews-footer');
          } else if (footerEl) {
            footerEl.setAttribute('data-sb-motion-linked-state', 'static');
          }

          window.SBSectionMotion?.initScope(itemsEl);

          if (resultCountEl) {
            resultCountEl.hidden = query === '' || list.length === 0;
            if (query !== '' && list.length > 0) {
              const formattedCount = numberFormat.format(totalCount);
              const label = totalCount === 1
                ? root.dataset.searchResultFoundLabel
                : root.dataset.searchResultsFoundLabel;
              resultCountEl.textContent = String(label || '').replace('__COUNT__', formattedCount);
            }
          }

          const canGrow = visibleCount < totalCount && (proxyUrl !== '' || visibleCount < list.length);
          moreButton.style.display = canGrow ? '' : 'none';
          const showEmpty = hasFilter() && list.length === 0;
          if (emptyEl) emptyEl.hidden = !showEmpty;
          if (footerEl) footerEl.hidden = showEmpty || !canGrow;
          if (isPhotoLayout) {
            // Reuse the current formatter on retained server cards as well as new cards.
            itemsEl.querySelectorAll('time[datetime]').forEach(time => {
              const review = reviewStore.get(time.closest('[data-review-key]')?.dataset.reviewKey);
              time.textContent = review?.relative_date || relTime(time.dateTime, snapshot.reference_at);
            });
            syncPhotoMasonry();
          }
        };

        root.addEventListener('click', (event) => {
          const button = event.target.closest('[data-translation-toggle]');
          const card = button?.closest('[data-review-key]');
          if (!(button instanceof HTMLButtonElement) || !(card instanceof HTMLElement)) return;
          const review = reviewStore.get(card.dataset.reviewKey || '');
          if (!review) return;
          const contentType = button.dataset.translationToggle;
          if (contentType === 'reply' && review.reply?.translation) {
            const showOriginal = card.dataset.showOriginalReply !== 'true';
            card.dataset.showOriginalReply = String(showOriginal);
            const bodyEl = card.querySelector('[data-reply-body]');
            const toggle = card.querySelector('[data-translation-toggle="reply"]');
            if (bodyEl) bodyEl.innerHTML = paragraphTextHtml(normalizeReplyMarkdown(showOriginal ? review.reply.original_body : review.reply.body));
            if (toggle) toggle.textContent = showOriginal
              ? root.dataset.showTranslationLabel
              : root.dataset.showOriginalLabel;
            return;
          }
          if (contentType !== 'review' || !review.translation) return;
          const showOriginal = card.dataset.showOriginalReview !== 'true';
          card.dataset.showOriginalReview = String(showOriginal);
          const title = showOriginal ? review.original_title : review.title;
          const body = showOriginal ? review.original_body : review.body;
          const titleEl = card.querySelector('[data-review-title]');
          if (titleEl) {
            titleEl.textContent = title || '';
            titleEl.hidden = !title;
          }
          const bodyEl = card.querySelector('[data-review-body]');
          const toggle = card.querySelector('[data-translation-toggle="review"]');
          if (bodyEl) bodyEl.innerHTML = paragraphTextHtml(body);
          if (toggle) toggle.textContent = showOriginal
            ? root.dataset.showTranslationLabel
            : root.dataset.showOriginalLabel;
        });

        root.querySelector('[data-review-media-modal-close]')?.addEventListener('click', closeMediaModal);
        mediaModal?.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeMediaModal();
        });
        mediaModal?.addEventListener('click', (event) => {
          if (event.target === mediaModal) closeMediaModal();
        });
        mediaModal?.addEventListener('keydown', (event) => {
          trapMediaModalFocus(event);
          if (event.key === 'Tab') mediaModal.removeAttribute('data-pointer-open');
          if (event.key === 'Escape' && usesMobileDocumentLayer()) {
            event.preventDefault();
            closeMediaModal();
          }
        });
        window.addEventListener('resize', requestMediaModalViewportUpdate, { passive: true, signal });
        window.addEventListener('orientationchange', requestMediaModalViewportUpdate, { signal });
        window.visualViewport?.addEventListener('resize', requestMediaModalViewportUpdate, { passive: true, signal });
        window.visualViewport?.addEventListener('scroll', requestMediaModalViewportUpdate, { passive: true, signal });

        const setLoading = (on) => {
          root.classList.toggle('sb-reviews-list--loading', on);
          moreButton.disabled = on;
          moreButton.classList.toggle('is-loading', on);
          moreButton.setAttribute('aria-busy', String(on));
        };

        const snapshotFromData = (data) => ({
          count: data.count || (data.reviews || []).length,
          distribution: data.distribution || {},
          type_counts: data.type_counts || {},
          custom_questions_summary: data.custom_questions_summary || [],
          sort_mode: data.sort_mode || 'recent',
          dataset_id: data.dataset_id || null,
          reference_at: data.reference_at || data.dataset_reference_at || '',
          reviews: isPhotoLayout ? photoReviews(data.reviews || []) : (data.reviews || []).slice(),
        });
        const ssrSnapshot = ssrData ? snapshotFromData(ssrData) : null;

        const combinedDistribution = (productSnapshot, storeSnapshot) => {
          const productCount = Math.max(0, Number(productSnapshot?.count) || 0);
          const storeCount = Math.max(0, Number(storeSnapshot?.count) || 0);
          const combinedCount = productCount + storeCount;
          if (combinedCount === 0) return productSnapshot?.distribution || {};
          return [5, 4, 3, 2, 1].reduce((distribution, star) => {
            const productPercent = Number(productSnapshot?.distribution?.[star]) || 0;
            const storePercent = Number(storeSnapshot?.distribution?.[star]) || 0;
            distribution[star] = Math.round(((productPercent * productCount) + (storePercent * storeCount)) / combinedCount);
            return distribution;
          }, {});
        };

        const renderSummary = () => {
          const distribution = isShopScope && snapshots.store
            ? combinedDistribution(snapshots.product, snapshots.store)
            : snapshots.product?.distribution || {};
          renderDist(distribution);
          renderCustomSummary(snapshots.product?.custom_questions_summary || []);
          initializeSummaryProgress();
        };

        const applySnapshot = (type, { revealNewItems = false } = {}) => {
          const nextSnapshot = snapshots[type];
          if (!nextSnapshot || reviewType !== type) return;
          snapshot = nextSnapshot;
          updateTypeCounts();
          list = snapshot.reviews.slice();
          displayedSort = snapshot.sort_mode;
          syncFilterUi();
          totalCount = Math.max(snapshot.count, list.length);
          render({ revealNewItems });
        };

        let storeSnapshotRequest = null;
        const loadStoreSnapshot = () => {
          if (snapshots.store) return Promise.resolve(snapshots.store);
          if (!storeDataUrl) return Promise.reject(new Error('Missing store snapshot URL'));
          if (!storeSnapshotRequest) {
            storeSnapshotRequest = (snapshots.product?.dataset_id
              ? proxyFetch(1, PAGE_SIZE, { sort: 'auto', type: 'store', unfiltered: true })
              : fetch(storeDataUrl, { signal })
              .then((res) => {
                if (!res.ok) throw new Error(res.status);
                return res.json();
              }))
              .then((data) => {
                snapshots.store = snapshotFromData(data);
                return snapshots.store;
              })
              .catch((error) => {
                storeSnapshotRequest = null;
                throw error;
              });
          }
          return storeSnapshotRequest;
        };

        /* Re-derive the list for the active filters from page 1 */
        // A refresh landing while the native filter menu is open re-renders
        // the list under it, and macOS dismisses select menus on layout
        // shift - the "reopen quickly and it closes itself" bug. Defer any
        // result until the select blurs (menu closed).
        const pendingWhileMenuOpen = [];
        const runOrDefer = (fn) => {
          const menuOpen = filterSelect
            && document.activeElement === filterSelect
            && !filterSelect.closest('.sb-field')?.classList.contains('is-settled');
          if (menuOpen) {
            pendingWhileMenuOpen.push(fn);
            return;
          }
          fn();
        };

        const refresh = ({ revealNewItems = false } = {}) => {
          visibleCount = PAGE_SIZE;
          nextPage = 2;
          if (reviewType === 'store' && !snapshots.store) {
            const seq = ++fetchSeq;
            setLoading(true);
            loadStoreSnapshot().then(() => {
              if (seq === fetchSeq) refresh({ revealNewItems });
            }).catch(() => { if (seq === fetchSeq) setLoading(false); });
            return;
          }
          if (!hasFilter() && (!sortChoice || snapshots[reviewType]?.sort_mode === effectiveSort())) {
            const seq = ++fetchSeq;
            const seq0 = seq;
            runOrDefer(() => {
              if (seq0 !== fetchSeq) return;
              setLoading(false);
              applySnapshot(reviewType, { revealNewItems });
            });
            return;
          }
          const seq = ++fetchSeq;
          setLoading(true);
          proxyFetch(1, REQUEST_PAGE_SIZE)
            .then((data) => {
              if (seq !== fetchSeq) return;
              runOrDefer(() => {
                if (seq !== fetchSeq) return;
                snapshot = Object.assign({}, snapshot, {
                  reference_at: data.dataset_reference_at || snapshot.reference_at || '',
                });
                list = (isPhotoLayout ? photoReviews(data.reviews || []) : (data.reviews || [])).map(normalize);
                displayedSort = data.sort_mode || 'recent';
                totalCount = data.count || list.length;
                syncFilterUi();
                updateTypeCounts();
                render({ revealNewItems });
              });
            })
            .catch(() => {
              if (seq !== fetchSeq || hasFilter()) return;
              runOrDefer(() => {
                if (seq !== fetchSeq) return;
                sortChoice = null;
                applySnapshot(reviewType, { revealNewItems });
              });
            })
            .then(() => { runOrDefer(() => { if (seq === fetchSeq) setLoading(false); }); });
        };

        moreButton.addEventListener('click', () => {
          const hasCachedPage = isPhotoLayout ? visibleCount < list.length : visibleCount + PAGE_SIZE <= list.length;
          const shouldUseSnapshotPage = proxyUrl === '' || (hasCachedPage && (isPhotoLayout || hasFilter() || displayedSort === 'relevant'));
          if (shouldUseSnapshotPage || list.length >= totalCount) {
            visibleCount += PAGE_SIZE;
            render({ revealNewItems: true });
            return;
          }
          const seq = ++fetchSeq;
          setLoading(true);
          const requestedPage = nextPage;
          proxyFetch(requestedPage, REQUEST_PAGE_SIZE)
            .then((data) => {
              if (seq !== fetchSeq) return;
              const identityToIndex = new Map(list.map((review, index) => [reviewIdentity(review), index]));
              (isPhotoLayout ? photoReviews(data.reviews || []) : (data.reviews || [])).map(normalize).forEach((r) => {
                const identity = reviewIdentity(r);
                if (identityToIndex.has(identity)) {
                  const index = identityToIndex.get(identity);
                  list[index] = Object.assign({}, list[index], r, {
                    custom_questions: r.custom_questions?.length
                      ? r.custom_questions
                      : list[index]?.custom_questions || [],
                  });
                } else {
                  identityToIndex.set(identity, list.length);
                  list.push(r);
                }
              });
              nextPage = requestedPage + 1;
              totalCount = data.reviews && data.reviews.length ? (data.count || list.length) : list.length;
              visibleCount += PAGE_SIZE;
              render({ revealNewItems: true });
            })
            // A failed request is not the end of the list. Keep the page and
            // count unchanged so the same button can retry.
            .catch(() => {})
            .then(() => { if (seq === fetchSeq) setLoading(false); });
        });

        const filterLabel = (star) => (root.dataset.filterLabel || '').replace('__STARS__', star);

        const distRowHtml = (star, pct) => {
          const safePercent = Math.max(0, Math.min(100, Number(pct) || 0));
          return `
          <button type="button" class="sb-reviews-list__dist-row${proxyUrl ? ' sb-reviews-list__dist-row--filterable' : ''}"
            data-dist-star="${star}" aria-pressed="false" aria-label="${esc(filterLabel(star))}">
            <span class="sb-reviews-list__dist-label font-body weight-regular">${star}</span>
            <span class="sb-reviews-list__dist-star" style="--sb-star-icon-url: url('${starIconUrl}');"></span>
            <span class="sb-reviews-list__dist-bar"><span class="sb-reviews-list__dist-bar-fill" data-sb-progress-fill style="width: ${safePercent}%;"></span></span>
            <span class="sb-reviews-list__dist-pct font-body weight-regular">${safePercent}%</span>
          </button>`;
        };

        const renderDist = (distribution) => {
          distEl.innerHTML = [5, 4, 3, 2, 1].map((star) => distRowHtml(star, distribution[star] || 0)).join('');
        };

        const syncFilterUi = () => {
          distEl.querySelectorAll('[data-dist-star]').forEach((el) => {
            const active = Number(el.dataset.distStar) === filterRating;
            el.setAttribute('aria-pressed', String(active));
            el.classList.toggle('sb-reviews-list__dist-row--active', active);
          });
          distEl.classList.toggle('sb-reviews-list__summary-dist--filtering', filterRating > 0);
          if (filterSelect) {
            const defaultSort = snapshots[reviewType]?.sort_mode || (reviewType === 'product' ? root.dataset.defaultSort : 'recent') || 'recent';
            const defaultOption = Array.from(filterSelect.options).find(option => option.value === defaultSort);
            if (defaultOption && filterSelect.firstElementChild !== defaultOption) filterSelect.prepend(defaultOption);
            filterSelect.value = photosOnly && !isPhotoLayout ? 'photos' : filterRating ? `rating-${filterRating}` : displayedSort;
            if (filterValueEl) filterValueEl.textContent = filterSelect.selectedOptions[0]?.textContent || '';
            filterSelect.closest('.sb-reviews-list__filter-field').classList.toggle(
              'sb-reviews-list__filter-field--active',
              filterSelect.value !== defaultSort
            );
          }
        };

        typeTabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const nextType = tab.dataset.reviewType;
            if (nextType === reviewType) return;
            reviewType = nextType;
            syncReviewTypeUi();
            refresh();
          });
        });

        distEl.addEventListener('click', (e) => {
          const row = e.target.closest('[data-dist-star]');
          if (!row || proxyUrl === '') return;
          const star = Number(row.dataset.distStar);
          filterRating = filterRating === star ? 0 : star;
          photosOnly = isPhotoLayout;
          syncFilterUi();
          refresh();
        });

        if (filterSelect) {
          if (proxyUrl === '') {
            filterSelect.closest('.sb-reviews-list__filter-field').hidden = true;
          } else {
            const filterField = filterSelect.closest('.sb-field');
            let filterPointerArmed = false;
            filterSelect.addEventListener('pointerdown', () => {
              filterPointerArmed = true;
              filterField?.classList.remove('is-settled');
              filterSelect.focus();
            });
            // Freeze the list region's height while the menu is focused:
            // whatever settles late (fetch results, images, reveal motion)
            // cannot shrink the page under the open popover - macOS closes
            // select menus on layout shift.
            filterSelect.addEventListener('focus', () => {
              if (itemsEl) itemsEl.style.minHeight = `${itemsEl.offsetHeight}px`;
            });
            filterSelect.addEventListener('blur', () => {
              filterPointerArmed = false;
              filterField?.classList.remove('is-settled');
              while (pendingWhileMenuOpen.length) pendingWhileMenuOpen.shift()();
              if (itemsEl) itemsEl.style.minHeight = '';
            });
            // macOS swallows the click that dismisses the native menu, so the
            // outside-pointerdown release below never saw it and the open
            // state survived one interaction too long. The page receives no
            // mouse events while the menu is open, so the first mousemove
            // outside the chip is a reliable "menu closed" signal.
            document.addEventListener('mousemove', (event) => {
              if (!filterPointerArmed || document.activeElement !== filterSelect) return;
              if (!filterSelect.closest('.sb-reviews-list__filter-field').contains(event.target)) {
                filterSelect.blur();
              }
            }, { signal });
            filterSelect.addEventListener('keydown', (event) => {
              if (event.key === 'Escape') filterSelect.blur();
            });
            // Dismissing the native menu by clicking away keeps the select
            // focused (Safari never blurs on non-focusable clicks), which
            // locked the open state in. Any pointerdown outside the chip
            // releases it.
            document.addEventListener('pointerdown', (event) => {
              if (document.activeElement === filterSelect
                && !filterSelect.closest('.sb-reviews-list__filter-field').contains(event.target)) {
                filterSelect.blur();
              }
            }, { signal });
            filterSelect.addEventListener('change', () => {
              const value = filterSelect.value;
              if (value === 'recent' || value === 'relevant') sortChoice = value;
              photosOnly = isPhotoLayout || value === 'photos';
              filterRating = value.startsWith('rating-') ? Number(value.slice(7)) : 0;
              // No blur here: blurring while macOS tears the popover down
              // clobbered a quick reopen. The settled class idles the
              // styling; focus stays until a real outside interaction.
              filterField?.classList.add('is-settled');
              syncFilterUi();
              refresh();
            });
          }
        }

        if (searchInput) {
          if (proxyUrl === '') {
            searchInput.style.display = 'none';
          } else {
            const applySearchQuery = () => {
              clearTimeout(searchDebounce);
              const value = searchInput.value.trim();
              const next = value.length >= 2 ? value : '';
              if (next === query) return;
              query = next;
              refresh();
            };
            searchInput.addEventListener('input', () => {
              clearTimeout(searchDebounce);
              searchDebounce = setTimeout(applySearchQuery, 350);
            });
            searchInput.addEventListener('keydown', (event) => {
              if (event.key !== 'Enter') return;
              event.preventDefault();
              applySearchQuery();
              searchInput.blur();
            });
          }
        }

        if (clearButton) {
          clearButton.addEventListener('click', () => {
            query = '';
            filterRating = 0;
            photosOnly = isPhotoLayout;
            if (searchInput) searchInput.value = '';
            syncFilterUi();
            refresh();
          });
        }

        if (savedSnapshots?.product) {
          snapshots.product = snapshotFromData(savedSnapshots.product);
          snapshots.store = savedSnapshots.store && (!snapshots.product.dataset_id || savedSnapshots.store.dataset_id === snapshots.product.dataset_id) ? snapshotFromData(savedSnapshots.store) : null;
          snapshot = snapshots.product;
          renderSummary();
          syncReviewTypeUi();
          refresh();
        } else if (ssrSnapshot && !isShopScope) {
          // Keep the chronological server fallback intact when a product has
          // not received its native snapshot yet. Never replace it on startup.
          snapshots.product = ssrSnapshot;
          snapshot = ssrSnapshot;
          renderedKeys = serverReviewElements.map((item) => item.dataset.reviewKey);
          renderSummary();
          syncReviewTypeUi();
          refresh();
        } else {
          // Last-resort data for a scope with neither native nor server cards.
          fetch(dataUrl, { signal })
            .then((res) => { if (!res.ok) throw new Error(res.status); return res.json(); })
            .then((data) => {
              snapshots.product = snapshotFromData(data);
              snapshot = snapshots.product;
              renderSummary();
              syncReviewTypeUi();
              refresh({ revealNewItems: !ssrSnapshot });
            })
            .catch(() => { if (!ssrSnapshot) moreButton.style.display = 'none'; });
        }

        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(root)) return;
          closeMediaModal();
          medalsObserver?.disconnect();
          photoMasonryObserver?.disconnect();
          cancelAnimationFrame(photoMasonryFrame);
          clearTimeout(searchDebounce);
          ++fetchSeq;
          lifecycle.abort();
          delete root.dataset.sbReviewsInit;
        }, { signal });
      };

      initReviewsList(document.querySelector('[data-sb-reviews-list]'));

      /* Theme editor + CLI hot reload replace section DOM without executing
         inline scripts; re-init on the section:load event they dispatch. */
      if (!window.__sbReviewsListBound) {
        window.__sbReviewsListBound = true;
        document.addEventListener('shopify:section:load', (e) => {
          initReviewsList(e.target.querySelector('[data-sb-reviews-list]'));
        });
      }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Instant type switching on the search page. The pills stay real links
  // (no-JS, new-tab, and middle-click all keep navigating); a plain left
  // click swaps the results region client-side via the Section Rendering
  // API, with the other two types prefetched after idle so switches are
  // instant. Falls back to a normal navigation on any fetch failure.
  (() => {
    // Native links survive editor section replacement without a second controller lifecycle.
    if (window.Shopify?.designMode) return;
    const root = document.querySelector('[data-sb-search-root]');
    if (!root) return;
    const segmented = root.querySelector('.sb-search__segmented');
    const region = root.querySelector('[data-sb-search-results]');
    const typeInput = root.querySelector('.sb-search__form input[name="type"]');
    if (!segmented || !region) return;

    const pills = Array.from(segmented.querySelectorAll('[data-search-segment-type]'));
    const sectionId = root.dataset.searchSectionId || '';
    const TYPES = ['product', 'page', 'article'];
    const indexOfType = (type) => Math.max(0, TYPES.indexOf(type));
    const cache = new Map();
    let currentType = typeInput?.value || 'product';
    let currentUrl = window.location.href;
    let arrivalTimer = 0;

    const urlFor = (type) => {
      const pill = pills.find((item) => item.dataset.searchSegmentType === type);
      return new URL(pill.href);
    };

    const fetchRegion = (type, targetUrl = urlFor(type)) => {
      const key = targetUrl.href;
      if (cache.has(key)) return cache.get(key);
      const url = new URL(targetUrl);
      url.searchParams.set('section_id', sectionId);
      const request = fetch(url, { credentials: 'same-origin' })
        .then(async (response) => {
          if (!response.ok) throw new Error(`${response.status}`);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('[data-sb-search-results]');
          if (!next) throw new Error('results region missing');
          return next.innerHTML;
        });
      cache.set(key, request);
      request.catch(() => cache.delete(key));
      return request;
    };

    const indicator = segmented.querySelector('.sb-search__segment-indicator');
    let arrivalController = null;

    // Ported from the PDP sticky segmented control: while the indicator
    // slides, the trailing cap tucks in on the slide easing (the arriving
    // class); when the slide's transitionend fires, the class comes off and
    // the cap springs back on the overshoot easing - the settle bounce.
    const clearSegmentArrival = () => {
      arrivalController?.abort();
      arrivalController = null;
      window.clearTimeout(arrivalTimer);
      arrivalTimer = 0;
      segmented.classList.remove('is-arriving-left', 'is-arriving-right');
    };

    const parseCssTime = (value, fallback) => {
      const normalized = String(value || '').trim();
      const amount = Number.parseFloat(normalized);
      if (!Number.isFinite(amount)) return fallback;
      return normalized.endsWith('ms') ? amount : amount * 1000;
    };

    const animateSegmentArrival = (direction) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const arrivalClass = direction === 'right' ? 'is-arriving-right' : 'is-arriving-left';
      const trailingHalf = segmented.querySelector(
        direction === 'right' ? '.sb-search__segment-indicator-half--start' : '.sb-search__segment-indicator-half--end'
      );
      if (!trailingHalf || !indicator) return;

      clearSegmentArrival();
      const controlsStyle = window.getComputedStyle(segmented);
      const edgeDuration = parseCssTime(controlsStyle.getPropertyValue('--sb-segment-edge-duration'), 260);
      const slideDuration = parseCssTime(controlsStyle.getPropertyValue('--sb-segment-slide-duration'), 220);
      arrivalController = new AbortController();
      const { signal } = arrivalController;

      const expandEdge = () => {
        if (signal.aborted || !segmented.classList.contains(arrivalClass)) return;
        window.clearTimeout(arrivalTimer);
        trailingHalf.addEventListener('transitionend', (event) => {
          if (event.propertyName === 'transform') clearSegmentArrival();
        }, { once: true, signal });
        segmented.classList.remove(arrivalClass);
        arrivalTimer = window.setTimeout(clearSegmentArrival, edgeDuration + 50);
      };

      segmented.classList.add(arrivalClass);
      indicator.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'transform') expandEdge();
      }, { once: true, signal });
      arrivalTimer = window.setTimeout(expandEdge, slideDuration + 50);
    };

    const applySegmentState = (type, direction) => {
      segmented.style.setProperty('--sb-search-segment-index', indexOfType(type));
      segmented.removeAttribute('data-segment-hover');
      pills.forEach((pill) => {
        const active = pill.dataset.searchSegmentType === type;
        pill.classList.toggle('is-active', active);
        pill.classList.toggle('weight-semibold', active);
        pill.classList.toggle('weight-medium', !active);
        if (active) pill.setAttribute('aria-current', 'page');
        else pill.removeAttribute('aria-current');
      });
      if (direction) animateSegmentArrival(direction);
    };

    const hydrateRegion = () => {
      if (window.SBSectionMotion && typeof window.SBSectionMotion.resetScope === 'function') {
        window.SBSectionMotion.resetScope(region);
      }
      const thumbnails = window.SBProductThumbnail;
      if (thumbnails) {
        if (typeof thumbnails.initThumbnailMediaScope === 'function') {
          thumbnails.initThumbnailMediaScope(region, { initSwatchInteractions: true });
        }
        if (typeof thumbnails.syncThumbnailDiscountPricingScope === 'function') {
          thumbnails.syncThumbnailDiscountPricingScope(region);
        }
      }
    };

    const swapTo = (type, { push = true } = {}) => {
      if (!TYPES.includes(type)) return;
      const targetUrl = push ? urlFor(type) : new URL(window.location.href);
      if (targetUrl.href === currentUrl) return;
      currentUrl = targetUrl.href;
      const direction = indexOfType(type) > indexOfType(currentType) ? 'right' : 'left';
      currentType = type;
      if (typeInput) typeInput.value = type;
      applySegmentState(type, direction);
      if (push) window.history.pushState({ sbSearchType: type }, '', targetUrl);
      fetchRegion(type, targetUrl)
        .then((html) => {
          if (currentUrl !== targetUrl.href) return;
          region.innerHTML = html;
          hydrateRegion();
        })
        .catch(() => {
          if (currentUrl !== targetUrl.href) return;
          window.location.assign(targetUrl);
        });
    };

    pills.forEach((pill) => {
      pill.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        swapTo(pill.dataset.searchSegmentType);
      });
      pill.addEventListener('pointerenter', () => {
        if (pill.classList.contains('is-active')) return;
        const direction = indexOfType(pill.dataset.searchSegmentType) > indexOfType(currentType) ? 'right' : 'left';
        segmented.setAttribute('data-segment-hover', direction);
      });
      pill.addEventListener('pointerleave', () => {
        segmented.removeAttribute('data-segment-hover');
      });
    });

    window.addEventListener('popstate', () => {
      const type = new URL(window.location.href).searchParams.get('type') || 'product';
      swapTo(type, { push: false });
    });

    const idle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1500));
    idle(() => {
      TYPES.filter((type) => type !== currentType).forEach((type) => {
        fetchRegion(type).catch(() => {});
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-card"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // The inline helper applies affiliate content before first paint. Reuse it
    // when Shopify replaces a section, the page returns, or pricing is ready.
    const syncSeasonalCards = () => {
      const state = window.SBAffiliateState?.read();
      document.querySelectorAll('[data-hero-card-seasonal="true"]').forEach((card) => {
        if (state) window.SBAffiliateHero?.applyToCard(card, state);
        else window.SBAffiliateHero?.restoreCard(card);
        window.SBAffiliateHero?.syncThresholdDisplay(card);
      });
      if (!state) {
        document.documentElement.style.removeProperty('--sb-affiliate-hero-bg-mobile');
        document.documentElement.style.removeProperty('--sb-affiliate-hero-bg-desktop');
      }
      document.documentElement.classList.remove('sb-affiliate-hero-pending');
    };

    window.addEventListener('pageshow', syncSeasonalCards);
    document.addEventListener('shopify:section:load', syncSeasonalCards);
    document.addEventListener('sb:storefront-pricing:changed', syncSeasonalCards);
    syncSeasonalCards();

    const productCardStates = new Map();
    const initProductCards = () => {
      document.querySelectorAll('[data-hero-card-product-mode]').forEach((card) => {
        if (productCardStates.has(card)) return;

        const variantIdInput = card.querySelector('[data-hero-card-variant-id]');
        const currentPriceElement = card.querySelector('[data-hero-card-current-price]');
        const comparePriceElement = card.querySelector('[data-hero-card-compare-price]');
        const form = card.querySelector('[data-hero-card-product-form]');
        const submitButton = card.querySelector('[data-hero-card-submit]');
        const buttonLabel = card.querySelector('[data-hero-card-button-label]');
        const buttonIcon = card.querySelector('.sb-framing-card__product-button-icon');
        const buttonCopy = card.querySelector('.sb-framing-card__product-button-copy');
        const currencyCode = `${card.dataset.currency || ''}`.trim().toUpperCase();
        const productId = card.dataset.productId || '';
        const hideDiscounts = card.dataset.hideDiscounts === 'true';
        if (
          !variantIdInput
          || !currentPriceElement
          || !comparePriceElement
          || !form
          || !submitButton
          || !buttonLabel
          || !buttonIcon
          || !buttonCopy
        ) return;

        const controller = new AbortController();
        const { signal } = controller;
        const storefrontPricing = window.SBStorefrontPricing || null;
        const priceFitClass = 'is-price-constrained';
        const minimumButtonEdgeSpace = 16;

        const syncButtonPriceFit = () => {
          if (signal.aborted) return;
          submitButton.classList.remove(priceFitClass);
          if (comparePriceElement.hidden) return;

          const buttonStyles = window.getComputedStyle(submitButton);
          const buttonGap = Number.parseFloat(buttonStyles.columnGap) || 0;
          const buttonHorizontalChrome = [
            buttonStyles.paddingLeft,
            buttonStyles.paddingRight,
            buttonStyles.borderLeftWidth,
            buttonStyles.borderRightWidth,
          ].reduce((total, value) => total + (Number.parseFloat(value) || 0), 0);
          const fullButtonWidth =
            buttonHorizontalChrome
            + buttonIcon.getBoundingClientRect().width
            + buttonGap
            + buttonCopy.scrollWidth;
          const availableButtonWidth = Math.max(0, card.clientWidth - (minimumButtonEdgeSpace * 2));
          submitButton.classList.toggle(priceFitClass, fullButtonWidth > availableButtonWidth);
        };

        const resizeObserver = new ResizeObserver(syncButtonPriceFit);
        resizeObserver.observe(form);
        productCardStates.set(card, () => {
          controller.abort();
          resizeObserver.disconnect();
        });
        document.fonts?.ready.then(syncButtonPriceFit);

        const formatMoney = (centsValue) => {
          const amountInCents = Number(centsValue) || 0;
          return storefrontPricing && typeof storefrontPricing.formatMoney === 'function'
            ? storefrontPricing.formatMoney(amountInCents, currencyCode, { context: 'storefront' })
            : `${Math.round(amountInCents / 100)}`;
        };

        const resolveDisplayPrice = (priceCents, comparePriceCents, overrideProductId = productId) => {
          if (hideDiscounts) {
            return { currentPriceCents: Number(priceCents) || 0, comparePriceCents: null };
          }
          if (storefrontPricing && typeof storefrontPricing.resolvePrice === 'function') {
            const resolved = storefrontPricing.resolvePrice({
              productId: overrideProductId,
              priceCents,
              comparePriceCents,
            }) || {};
            const currentPriceCents = Number(resolved.currentPriceCents);
            const resolvedComparePriceCents = Number(resolved.comparePriceCents);
            return {
              currentPriceCents: Number.isFinite(currentPriceCents) ? currentPriceCents : Number(priceCents || 0),
              comparePriceCents:
                Number.isFinite(resolvedComparePriceCents) && resolvedComparePriceCents > currentPriceCents
                  ? resolvedComparePriceCents
                  : null,
            };
          }

          const normalizedPrice = Number(priceCents) || 0;
          const normalizedCompare = Number(comparePriceCents) || 0;
          return {
            currentPriceCents: normalizedPrice,
            comparePriceCents: normalizedCompare > normalizedPrice ? normalizedCompare : null,
          };
        };

        let activePriceVariant = null;
        const applyVariant = (variant) => {
          if (!variant || !variant.id) return;
          activePriceVariant = variant;
          variantIdInput.value = `${variant.id}`;
          const priceValue = Number(variant.price) || 0;
          const comparePriceValue = Number(variant.compare_at_price) || 0;
          const resolvedPricing = resolveDisplayPrice(priceValue, comparePriceValue, variant.product_id || productId);
          const hasCompare =
            Number.isFinite(resolvedPricing.comparePriceCents)
            && resolvedPricing.comparePriceCents > resolvedPricing.currentPriceCents;
          currentPriceElement.textContent = formatMoney(resolvedPricing.currentPriceCents);
          if (hasCompare) {
            comparePriceElement.textContent = formatMoney(resolvedPricing.comparePriceCents);
            comparePriceElement.hidden = false;
          } else {
            comparePriceElement.textContent = '';
            comparePriceElement.hidden = true;
          }

          const isAvailable = variant.available !== false;
          const availableLabel = submitButton.dataset.labelAvailable || '';
          const unavailableLabel = submitButton.dataset.labelUnavailable || '';
          const nextLabel = isAvailable ? availableLabel : unavailableLabel;
          buttonLabel.textContent = nextLabel;
          submitButton.dataset.variantAvailable = String(isAvailable);
          submitButton.disabled = !isAvailable || submitButton.dataset.cartSubmitPending === 'true';
          submitButton.setAttribute('aria-label', nextLabel);
          syncButtonPriceFit();
        };

        applyVariant({
          id: Number(card.dataset.initialVariantId || '0'),
          available: card.dataset.initialAvailable === 'true',
          price: Number(card.dataset.initialPrice || '0'),
          compare_at_price: Number(card.dataset.initialComparePrice || '0'),
        });

        const syncFromSelectedProductItem = () => {
          if (signal.aborted) return;
          const productRoot = Array.from(document.querySelectorAll('.sb-product-main')).find(
            (node) => `${node.dataset.productId || ''}` === `${productId}`
          );
          if (!productRoot) return;
          const selectedSelectorItem = productRoot.querySelector('[data-selector-list-item].is-selected');
          if (!(selectedSelectorItem instanceof HTMLElement)) return;

          const selectedVariantId = Number(selectedSelectorItem.dataset.variantId || '0');
          if (!selectedVariantId) return;

          applyVariant({
            id: selectedVariantId,
            available: selectedSelectorItem.dataset.variantAvailable === 'true',
            product_id: selectedSelectorItem.dataset.variantProductId || productId,
            price: Number(selectedSelectorItem.dataset.variantPrice || '0'),
            compare_at_price: Number(selectedSelectorItem.dataset.variantComparePrice || '0'),
          });
        };

        syncFromSelectedProductItem();

        document.addEventListener('click', (event) => {
          const item = event.target instanceof Element ? event.target.closest('[data-selector-list-item]') : null;
          if (!item || item.dataset.selectorListMode === 'variant') return;
          if (item.closest('.sb-product-main')?.dataset.productId !== `${productId}`) return;
          syncFromSelectedProductItem();
        }, { signal });

        document.addEventListener('shopify:section:load', syncFromSelectedProductItem, { signal });

        document.addEventListener('variant:update', (event) => {
          const variant = event?.detail?.resource;
          const eventProductId = event?.detail?.data?.productId;
          if (!variant || `${eventProductId || ''}` !== `${productId}`) return;
          applyVariant(variant);
        }, { signal });

        document.addEventListener('sb:storefront-pricing:changed', () => {
          if (activePriceVariant) applyVariant(activePriceVariant);
        }, { signal });


      });
    };

    document.addEventListener('shopify:section:load', initProductCards);
    document.addEventListener('shopify:section:unload', (event) => {
      for (const [card, cleanup] of productCardStates) {
        if (event.target instanceof Element && event.target.contains(card)) {
          cleanup();
          productCardStates.delete(card);
        }
      }
    });
    initProductCards();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-breakdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.SBInitValueBreakdown) {
      window.SBInitValueBreakdown(document);
      return;
    }
    const sectionControllers = new WeakMap();

    const initValueBreakdownSection = (root) => {
      if (!root || sectionControllers.has(root)) return;

      const variantsElement = root.querySelector('[data-value-breakdown-variants]');
      const firstCompareElement = root.querySelector('[data-value-breakdown-first-compare]');
      const firstCurrentElement = root.querySelector('[data-value-breakdown-first-current]');
      const totalCompareElement = root.querySelector('[data-value-breakdown-total-compare]');
      const totalCurrentElement = root.querySelector('[data-value-breakdown-total-current]');
      const staticItemCompareElements = Array.from(root.querySelectorAll('[data-value-breakdown-item-compare]'));
      const mediaFrames = Array.from(root.querySelectorAll('[data-value-breakdown-image]'));
      const colorChips = Array.from(root.querySelectorAll('[data-value-breakdown-color-chip]'));
      const addButton = root.querySelector('[data-value-breakdown-add-button]');
      const variantInput = root.querySelector('[data-value-breakdown-variant-input]');
      const addButtonLabel = root.querySelector('[data-value-breakdown-add-button-label]');
      const extraCompareSumCents = Number.parseInt(root.dataset.extraCompareSumCents || '0', 10) || 0;
      const currencyCode = `${root.dataset.currency || ''}`.trim().toUpperCase();
      const productId = root.dataset.productId || '';
      const hideDiscounts = root.dataset.hideDiscounts === 'true';
      const storefrontPricing = window.SBStorefrontPricing || null;

      if (!variantsElement || !firstCompareElement || !firstCurrentElement || !totalCompareElement || !totalCurrentElement) return;

      const controller = new AbortController();
      sectionControllers.set(root, controller);
      const { signal } = controller;

      let variantsById = {};
      try {
        variantsById = JSON.parse(variantsElement.textContent || '{}') || {};
      } catch (error) {
        variantsById = {};
      }

      const formatMoney = (centsValue) => {
        const amount = Number(centsValue) || 0;
        if (storefrontPricing && typeof storefrontPricing.formatMoney === 'function') {
          return storefrontPricing.formatMoney(amount, currencyCode, { context: 'storefront' });
        }
        return `${Math.round(amount / 100)}`;
      };

      const syncStaticItemComparePrices = () => {
        staticItemCompareElements.forEach((priceElement) => {
          if (!(priceElement instanceof HTMLElement)) return;
          const priceCents = Number.parseInt(`${priceElement.dataset.priceCents || ''}`, 10);
          if (!Number.isFinite(priceCents) || priceCents <= 0) return;
          priceElement.textContent = formatMoney(priceCents);
        });
      };

      const resolveDisplayPrice = (priceCents, comparePriceCents) => {
        if (hideDiscounts) {
          return { currentPriceCents: Number(priceCents) || 0, comparePriceCents: null };
        }
        if (storefrontPricing && typeof storefrontPricing.resolvePrice === 'function') {
          const resolved = storefrontPricing.resolvePrice({
            productId,
            priceCents,
            comparePriceCents,
          }) || {};
          const currentPriceCents = Number(resolved.currentPriceCents);
          const resolvedComparePriceCents = Number(resolved.comparePriceCents);
          const normalizedCurrentPrice = Number.isFinite(currentPriceCents) ? currentPriceCents : Number(priceCents || 0);
          return {
            currentPriceCents: normalizedCurrentPrice,
            comparePriceCents:
              Number.isFinite(resolvedComparePriceCents) && resolvedComparePriceCents > normalizedCurrentPrice
                ? resolvedComparePriceCents
                : null,
          };
        }

        const normalizedPrice = Number(priceCents) || 0;
        const normalizedCompare = Number(comparePriceCents) || 0;
        return {
          currentPriceCents: normalizedPrice,
          comparePriceCents: normalizedCompare > normalizedPrice ? normalizedCompare : null,
        };
      };

      const getCurrentVariantId = () => `${
        root.dataset.currentVariantId
        || root.dataset.initialVariantId
        || ''
      }`;

      const syncVariantMedia = (variantId) => {
        if (mediaFrames.length === 0 && colorChips.length === 0) return;
        const normalizedVariantId = `${variantId || ''}`;
        const hasOwnImage = mediaFrames.some((frame) => frame.dataset.valueBreakdownImage === normalizedVariantId);
        const activeKey = hasOwnImage ? normalizedVariantId : 'fallback';
        mediaFrames.forEach((frame) => {
          frame.hidden = frame.dataset.valueBreakdownImage !== activeKey;
          if (frame.hidden) frame.querySelectorAll('video').forEach((video) => video.pause());
        });
        colorChips.forEach((chip) => {
          const isSelected = chip.dataset.variantId === normalizedVariantId;
          chip.classList.toggle('is-selected', isSelected);
          chip.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const syncVariantPricing = (variantId) => {
        const normalizedVariantId = `${variantId || ''}`;
        if (!normalizedVariantId) return;
        const variant = variantsById[normalizedVariantId];
        if (!variant) return;

        syncVariantMedia(normalizedVariantId);

        const resolvedPricing = resolveDisplayPrice(variant.price, variant.compareAtPrice);
        const currentPrice = Number(resolvedPricing.currentPriceCents || 0);
        const comparablePrice = Number(resolvedPricing.comparePriceCents || resolvedPricing.currentPriceCents || 0);
        const firstLineComparePrice = Math.max(comparablePrice - extraCompareSumCents, 0);
        const firstLineCurrentPrice = currentPrice;
        firstCompareElement.textContent = formatMoney(firstLineComparePrice);
        firstCurrentElement.textContent = formatMoney(firstLineCurrentPrice);
        totalCompareElement.textContent = formatMoney(comparablePrice);
        totalCurrentElement.textContent = formatMoney(currentPrice);

        root.dataset.currentVariantId = normalizedVariantId;
        if (variantInput) variantInput.value = normalizedVariantId;

        if (addButton) {
          const isAvailable = Boolean(variant.available);
          const availableLabel = addButton.dataset.labelAvailable || '';
          const unavailableLabel = addButton.dataset.labelUnavailable || '';
          const nextLabel = isAvailable ? availableLabel : unavailableLabel;
          addButton.dataset.variantAvailable = String(isAvailable);
          addButton.disabled = !isAvailable || addButton.dataset.cartSubmitPending === 'true';
          addButton.setAttribute('aria-label', nextLabel);
          if (addButtonLabel) addButtonLabel.textContent = nextLabel;
        }
      };

      const syncFromSelectedVariant = () => {
        syncVariantPricing(getCurrentVariantId());
      };

      syncStaticItemComparePrices();
      syncFromSelectedVariant();

      colorChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          if (addButton?.dataset.cartSubmitPending === 'true') return;
          const chipVariantId = `${chip.dataset.variantId || ''}`;
          if (!chipVariantId || chipVariantId === getCurrentVariantId()) return;
          syncVariantPricing(chipVariantId);
        }, { signal });
      });

      document.addEventListener('sb:storefront-pricing:changed', () => {
        syncStaticItemComparePrices();
        syncFromSelectedVariant();
      }, { signal });

      if (root.hasAttribute('data-sync-product-variant')) {
        document.addEventListener('variant:update', (event) => {
          if (`${event.detail?.data?.productId || ''}` !== productId) return;
          syncVariantPricing(event.detail?.resource?.id);
        }, { signal });
      }

    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-value-breakdown]').forEach((root) => initValueBreakdownSection(root));
    };

    window.SBInitValueBreakdown = initAll;
    initAll(document);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!(event.target instanceof Element)) return;
      event.target.querySelectorAll('[data-value-breakdown]').forEach((root) => {
        sectionControllers.get(root)?.abort();
        sectionControllers.delete(root);
      });
    });
    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target) return;
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
